import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { RegexConstants } from '@wz-constants';
import { environment } from '@wz-environments';
import {
  AgencyModels,
  CommonRiskModels,
  HealthModels,
  HealthRiskModels,
  QuotationModels,
} from '@wz-models';
import {
  AddressApiService,
  AuthenticationServiceBase,
  HealthInsuranceService,
  HealthQuotationApiService,
  InteractionService,
  LoadingService,
  LoggerService,
} from '@wz-services';
import { formatDate, getDateUtc } from '@wz-utilities/date.utilities';
import { getControlWithValueChanges } from '@wz-utilities/form.utilities';
import { WzDateValidators } from '@wz-validators';
import { addDays, addYears } from 'date-fns';
import * as $ from 'jquery';
import {
  FormGroupBaseComponent,
  getFormGroupBaseDirective,
} from 'libs/modules/tunnelsante-forms/components/form-group-base.component';
import { AniService } from 'libs/modules/tunnelsante/services/ani.service';
import { MtxDataLoginResponse } from 'libs/modules/tunnelsante/services/api/api-service-base';
import { MtxApiService } from 'libs/modules/tunnelsante/services/api/mtx-api.service';
import * as _ from 'lodash';
import { parseInt } from 'lodash';
import { DateTime } from 'luxon';
import { PolicyModels } from 'models/policy.models';
import { ValiderData } from 'models/valider-data.models';
import moment from 'moment';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Subscription, of } from 'rxjs';
import { startWith, takeUntil, tap } from 'rxjs/operators';
import 'slick-carousel/slick/slick.js';
import { AddressModels } from '../../../../../../models/address.models';
import { ErrorFraudeModalService } from '../../Souscriptions/error-fraude-modal/error-fraude-modal.service';
import { Enfant } from '../devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../devis-formulaire/Models/Personne';
import {
  Question,
  SkillTableItem,
  controlListe,
  factoryAgeValidators,
  getMinMaxAgeByPackage,
} from '../health-quotation-formB2C/factory-age-validators';
import { TaggingService } from '../services/tagging.service';

import POSTAL_CODE = RegexConstants.POSTAL_CODE;
import CityTemplateOptions = AddressModels.CityTemplateOptions;
import HealthAssureForm = HealthModels.HealthAssureForm;
import CitiesRepositoryEnum = AddressModels.CitiesRepositoryEnum;
import AgencyDetails = AgencyModels.AgencyDetails;

@Component({
  selector: 'wz-health-assure-formB2C',
  templateUrl: './health-assure-form.component.html',
  styleUrls: ['./health-assure-form.component.scss'],
  standalone: false,
  providers: [getFormGroupBaseDirective(HealthAssureFormComponentB2C)],
})
export class HealthAssureFormComponentB2C
  extends FormGroupBaseComponent<HealthModels.Assure>
  implements OnInit, OnChanges
{
  get agencyDetails(): AgencyModels.AgencyDetails {
    return this._agencyDetails;
  }

  @Input() set agencyDetails(value: AgencyModels.AgencyDetails) {
    this._agencyDetails = value;
  }
  private _agencyDetails: AgencyDetails | any;
  olderThan80(date: string): any {
    if (date) {
      return moment().diff(moment(date, 'dd/MM/yyyy'), 'years') >= 80;
    }
  }
  @Input() disabled!: boolean;
  @Input() package!: PolicyModels.PackageEnum;
  @Input() formula!: QuotationModels.FormulaEnum;
  @Input() controlListeParam!: Question[];

  @ViewChild('slickModal', { static: false })
  slickModal!: SlickCarouselComponent;
  @ViewChild('slickModal2', { static: false })
  slickModal2!: SlickCarouselComponent;
  inputDateNaissanceAssure: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event: any): any {
    if (this.slickModal !== undefined) {
      if (event.target.innerWidth < 1199) {
        if (!$.default('ngx-slick.cont-art-cm').hasClass('slick-initialized')) {
          let el = $.default('ngx-slick.cont-art-cm').find(
            'slick-slide.slick-current',
          );

          if (el.hasClass('art-cm')) {
            $.default('ngx-slick.cont-art-cm').attr('resized', '1');
          }

          ($.default('ngx-slick.cont-art-cm') as any).slick(this.slideConfig);
        }
      }
    }

    if (this.slickModal2 !== undefined) {
      if (event.target.innerWidth <= 1199) {
        if (
          !$.default('ngx-slick.container-partenar').hasClass(
            'slick-initialized',
          )
        ) {
          let el = $.default('ngx-slick.container-partenar').find(
            'slick-slide.slick-current',
          );

          if (el.hasClass('partner')) {
            $.default('ngx-slick.container-partenar').attr('resized', '1');
          }
          ($.default('ngx-slick.container-partenar') as any).slick(
            this.slideConfig,
          );
        }
      }
    }
  }

  @Output() regimeSocial = new EventEmitter<HealthModels.RegimeSocialEnum>();
  @Output() dateEffet: any = new EventEmitter<Date>();

  healthAssureFormModel: HealthAssureForm = {};
  nomCtrl!: FormControl;
  prenomCtrl!: FormControl;
  maxAge: number = 90;
  minAge: number | null = null;

  curentQuestion: number = 0;
  curentStep: number = 1;
  isUpdating = false;
  valider: boolean = false;

  healthEffectDateMin!: Date;

  private _dateEffet!: Date | any;

  dataTest!: SkillTableItem[];
  controlListe: Question[] = [];
  loading: boolean = false;

  nom_parrain: string | null = null;
  address1_parrain: string | null = null;
  postalcodeville: string | null = null;
  address2_parrain: string | null = null;
  prenoms_parrain: string | null = null;
  civility_parrain: string | null = null;

  //Personne informationss
  enfant: Enfant = new Enfant(0, []);
  niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );
  public personne!: Personne | any;

  public risk!: HealthRiskModels.Risk;

  override formGroup: FormGroup;
  public regimeSocialCtrl!: FormControl;
  public dateEffectCtrl!: FormControl;
  public dateNaissanceCtrl!: FormControl;
  public DateNaissanceMin!: Date;
  public formatDateNaissanceMin!: string | any;
  public DateNaissanceMax!: Date;
  public formatDateNaissanceMax!: string | any;
  public formatDateEffetMin!: string | any;
  public formatDateEffetMax!: string | any;
  public dateEffetMax = new Date();

  displayBtnR: boolean = false;
  displayBtnQ0: boolean = false;
  displayBtnQ1: boolean = false;
  displayBtnQRS: boolean = false;
  displayBtnQRSC: boolean = false;

  fMailError: boolean = false;

  fieldsAdresse: FormlyFieldConfig[] | any = [
    {
      key: 'groupVille',
      fieldGroupClassName: 'form-address__city',
      fieldGroup: [
        {
          key: 'codePostal',
          type: 'input',
          templateOptions: {
            type: 'test',
            label: 'Code postal',
            pattern: POSTAL_CODE,
            required: true,
            minLength: 5,
            maxLength: 5,
            change: (field: any) => {
              let group = this.fieldsAdresse
                .filter((x: any) => x.key == 'groupVille')
                .shift().fieldGroup;
              let cityField = group
                .filter((x: any) => x.key == 'ville')
                .shift();
              let inseeField = group
                .filter((x: any) => x.key == 'inseeCode')
                .shift();
              field.formControl.valueChanges
                .pipe(
                  startWith(field.formControl.value),
                  tap((codePostal: string) => {
                    let citiesList: CityTemplateOptions[];
                    if (codePostal && codePostal.length === 5) {
                      this.addressService
                        .getCities(codePostal, CitiesRepositoryEnum.Smalltox)
                        .subscribe((cities) => {
                          citiesList = cities.map((city) => {
                            let postalCode = _.padStart(
                              city.postalCodes[0],
                              5,
                              '0',
                            );
                            return {
                              label: city.name,
                              value: city.name,
                              codePostal: postalCode,
                              inseeCode: city.inseeCode,
                            };
                          });
                          cityField.templateOptions.options = citiesList.sort(
                            (a, b) =>
                              a.value < b.value
                                ? -1
                                : a.value > b.value
                                  ? 1
                                  : 0,
                          );
                          if (cities.length === 1) {
                            cityField.formControl.patchValue(cities[0].name, {
                              emitEvent: false,
                            });
                            inseeField.formControl.patchValue(
                              cities[0].inseeCode,
                              { emitEvent: false },
                            );
                          } else {
                            cityField.formControl.patchValue('');
                          }
                        });
                    } else if (!codePostal) {
                      cityField.formControl.patchValue('');
                    }
                  }),
                  takeUntil(this.destroy$),
                )
                .subscribe();
            },
          },
          validation: {
            messages: {
              pattern: (_: any, field: FormlyFieldConfig | any) =>
                `"${field.formControl.value}" n'est pas code postal valide`,
            },
          },
        },
        {
          key: 'ville',
          type: 'select',
          templateOptions: {
            label: `Ville`,
            placeholder: 'Choisir la ville',
            required: true,
            options: [],
          },
          hooks: {
            onChanges: (field: any) => {
              let group = this.fieldsAdresse
                .filter((x: any) => x.key == 'groupVille')
                .shift().fieldGroup;
              let codeField = group
                .filter((x: any) => x.key == 'codePostal')
                .shift();
              let inseeField = group
                .filter((x: any) => x.key == 'inseeCode')
                .shift();

              field.formControl.valueChanges
                .pipe(takeUntil(this.destroy$))
                .subscribe((ville: string) => {
                  if (ville) {
                    let options = [];
                    let actualCity: CityTemplateOptions;

                    options.push(field.templateOptions.options);

                    if (options[0].length) {
                      actualCity = options[0].filter(
                        (x: any) => x.value == ville,
                      )[0];
                      codeField.formControl.patchValue(actualCity.codePostal, {
                        emitEvent: false,
                      });
                      inseeField.formControl.patchValue(actualCity.inseeCode, {
                        emitEvent: false,
                      });
                    } else {
                      field.templateOptions.options = of([
                        { value: ville, label: ville },
                      ]);
                    }
                  }
                });
            },
          },
        },
        {
          key: 'inseeCode',
        },
      ],
    },
  ];

  dateDuJour!: Date;
  dateDuJourNaissance!: Date;
  dateDuJourEffet!: Date;

  //Email phone control
  phoneCtrl!: FormControl;
  emailCtrl!: FormControl;
  codePostalCtrl!: FormControl;

  //DATE NAISSANCE ENFANT:
  dateNaissanceEnfantForm: FormGroup;
  value_fromPage1: string | any = ''; //Personne Model model in current Session
  valueLocalStorage_from: string | any = '';
  value_fromPage2: string | any = '';
  dateMaxEnfant!: Date;
  //Page Order
  pageOrder: Array<number> = [];

  //Tagging
  VisiteurId!: string;

  // Google ads
  gclid!: string | any;
  // Bing ads
  msclkid!: string | any;

  //Texte infobulle niveau remboursement
  besoins: any = HealthModels.BesoinsTypeIGDEnum;

  slides: any = [342, 453, 846, 855, 234, 564, 744, 243];

  slideConfig: any = {
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    infinite: false,
    initialSlide: 0,
    centerMode: false,
    variableWidth: true,

    responsive: [
      {
        breakpoint: 6000,
        settings: 'unslick',
      },
      {
        breakpoint: 1400,
        settings: 'unslick',
      },
      {
        breakpoint: 1200,
        settings: 'unslick',
      },

      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  };

  public showDiv = false;

  currentHeader: string = '';
  currentFooter: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private fb: FormBuilder,
    private addressService: AddressApiService,
    public authService: AuthenticationServiceBase<any, any>,
    @Inject(DOCUMENT) document: any,
    @Inject(HealthInsuranceService)
    private healthInsuranceService: HealthInsuranceService | any,
    private taggingService: TaggingService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private cookieService: CookieService,
    private mtxApiService: MtxApiService,
    private aniService: AniService,
    private healthQuotationApiService: HealthQuotationApiService,
    private fraudeModalService: ErrorFraudeModalService,
    private loggerService: LoggerService,
    private interactionService: InteractionService,
  ) {
    super();

    this.getScreenSize({ target: window });
    this.formGroup = this.createFormGroup();

    this.dateNaissanceEnfantForm = this.formBuilder.group({
      name: '',
      dateNaissanceEnfant: this.formBuilder.array([]),
    });

    this.quotationNavigator = this.healthInsuranceService.getInfoNavigator();
  }

  ngAfterViewChecked() {
    this.applyStylesAndImages();
  }

  applyStylesAndImages() {
    // La bonne Mutuelle
    this.updateDOM(
      'labonnemutuelle_affiliation',
      'bodyLaBonneMutuelleSubContainer',
      {
        horloge: 'assets/img/horloge-la-bonne-mutuelle.svg',
        soinsMedicaux: 'assets/img/heartbeat-solid-labonnemutuelle 1.svg',
        ambulance: 'assets/img/ambulance-labonnemutuelle.svg',
        dentaire: 'assets/img/tooth-solid 1-labonnemutuelle.svg',
        optique: 'assets/img/glasses-alt-regular 1-labonnemutuelle.svg',
        audit: 'assets/img/ear-solid 1-labonnemutuelle.svg',
      },
    );
    // AFI Sante
    this.updateDOM('afisante_affiliation', 'bodyAffiliationSubContainer', {
      horloge: 'assets/img/horloge-affiliation-afi-sante.svg',
      soinsMedicaux: 'assets/img/heartbeat-solid-afisante 1.svg',
      ambulance: 'assets/img/ambulance-afisante.svg',
      dentaire: 'assets/img/tooth-solid 1-afisante.svg',
      optique: 'assets/img/glasses-alt-regular 1-afisante.svg',
      audit: 'assets/img/ear-solid 1-afisante.svg',
    });

    //mutuelle online
    this.updateDOM(
      'mutuelleonline_affiliation',
      'bodyMutuelleOnlineContainer',
      {
        horloge: 'assets/img/horloge-mutuelle-online.svg',
        soinsMedicaux: 'assets/img/heartbeat-solid-mutuelle-online 1.svg',
        ambulance: 'assets/img/ambulance-mutuelle-online.svg',
        dentaire: 'assets/img/tooth-solid 1-mutuelle-online.svg',
        optique: 'assets/img/glasses-alt-regular 1-mutuelle-online.svg',
        audit: 'assets/img/ear-solid 1-mutuelle-online.svg',
      },
    );
    this.updateDOM(
      'assuranceetmutuelle_affiliation',
      'bodyAssuranceEtMutuelleContainer',
      {
        horloge: 'assets/img/horloge-assurance-et-mutuelle.svg',
        soinsMedicaux: 'assets/img/heartbeat-solid-assurance-et-mutuelle 1.svg',
        ambulance: 'assets/img/ambulance-assurance-et-mutuelle.svg',
        dentaire: 'assets/img/tooth-solid 1-assurance-et-mutuelle.svg',
        optique: 'assets/img/glasses-alt-regular-1-assurance-et-mutuelle.svg',
        audit: 'assets/img/ear-solid 1-assurance-et-mutuelle.svg',
      },
    );

    this.updateDOM('Mutuelle.com_affiliation', 'bodyMutuelleComContainer', {
      horloge: 'assets/img/horloge-mutuelle-com.svg',
      soinsMedicaux: 'assets/img/heartbeat-solid-mutuelle-com 1.svg',
      ambulance: 'assets/img/ambulance-mutuelle-com.svg',
      dentaire: 'assets/img/tooth-solid 1-mutuelle-com.svg',
      optique: 'assets/img/glasses-alt-regular 1-mutuelle-com.svg',
      audit: 'assets/img/ear-solid 1-mutuelle-com.svg',
    });
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }

  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.queryParamMap.get('gclid')) {
      this.gclid = this.route.snapshot.queryParamMap.get('gclid');
      let url = window.location.href;
      let params = new URLSearchParams(url);
      if (params.get('gclid')) this.gclid = params.get('gclid');
      sessionStorage.setItem('gclid', this.gclid);
    } else {
      this.gclid = this.getCookie('gclid');
      if (
        this.gclid &&
        this.gclid != 'EAIaIQobChMI_PylqPrF9wIVQ7TVCh3X3A93EAAYASAAEgL03_D_BwE'
      ) {
        sessionStorage.setItem('gclid', this.gclid);
      } else {
        this.gclid = this.getCookie('gclid_mtx');
        if (
          this.gclid &&
          this.gclid !=
            'EAIaIQobChMI_PylqPrF9wIVQ7TVCh3X3A93EAAYASAAEgL03_D_BwE'
        ) {
          sessionStorage.setItem('gclid', this.gclid);
        }
      }
    }

    if (this.route.snapshot.queryParamMap.get('msclkid')) {
      this.msclkid = this.route.snapshot.queryParamMap.get('msclkid');
      sessionStorage.setItem('msclkid', this.msclkid);
    }
    if (this.route.snapshot.queryParamMap.get('msclkid')) {
      this.msclkid = this.route.snapshot.queryParamMap.get('msclkid');
      sessionStorage.setItem('msclkid', this.msclkid);
    }
    this.controlListe = controlListe;
    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
      localStorage.getItem('parrain') || '',
    );
    this.personne.enfant.dateNaissanceEnfant[0] = ''; //Initialize to one value for inputDateNaissance displaying
    // this.risk.family.conjoint.personData.dateNaissance;
    // this.risk.assurePrincipal.personData.dateNaissance;
    //déclaration health service pour obetnir les données dans la memoire
    this.patchBirthdayValidators();
    this.healthEffectDateMin = this.getHealthEffectDateMin();
    this.formatDateEffetMin = formatDate(
      this.healthEffectDateMin,
      'yyyy-MM-dd',
    );
    // if (this.controlListe[0].QuestionValue != '0') {
    //     this.restoreData();
    // }

    let datenow = new Date();

    this.dateEffetMax.setDate(datenow.getDate() + 365);
    this.formatDateEffetMax = formatDate(this.dateEffetMax, 'yyyy-MM-dd');
    this.dateMaxEnfant = new Date(
      datenow.getFullYear() - 26,
      datenow.getMonth(),
      datenow.getDate(),
    );
    this.VisiteurId = this.taggingService.checkVisiteurId();
    //Get Data from sessionStorage : Model Personne
    this.value_fromPage1 = sessionStorage.getItem('app.personne');
    this.value_fromPage2 = sessionStorage.getItem('app.fromPage2');
    if (this.value_fromPage1 && this.value_fromPage2 == 'true') {
      this.personne = JSON.parse(this.value_fromPage1);
      switch (this.personne.compositionFamiliale) {
        case '1': {
          this.curentQuestion = 11;
          break;
        }
        case '2': {
          this.curentQuestion = 10;
          break;
        }
        case '3': {
          this.curentQuestion = 12;
          break;
        }
        case '4': {
          this.curentQuestion = 12;
          break;
        }

        default: {
          break;
        }
      }

      this.refreshTag(this.curentQuestion);
      this.restoreQuestionValue();
      sessionStorage.removeItem('app.fromPage2');
      sessionStorage.removeItem('app.personne');
      sessionStorage.removeItem('tokenData');
      //DateNaissance Enfant:
      //Add enfant control
      this.inputNumber = this.personne.enfant.nombreEnfants;
      this.getDatenaissanceinputValue();
    } else {
      //initialize le input par defaut dans dateNiassance enfant
      this.dateNaissanceEnfant().push(this.new_enfant(''));
      this.refreshTag(0);
    }

    let dataStr = localStorage.getItem('data.client.personne');
    let data: Personne = dataStr ? JSON.parse(dataStr) : null;

    //preremplier
    if (data != null) {
      this.personne = {
        ...data,
        niveauRemboursement: data.niveauRemboursement,
        dateDebutContrat:
          data.dateDebutContrat != ''
            ? this.formatDate(data.dateDebutContrat)
            : '',
        dateNaissanceAssure:
          data.dateNaissanceAssure != ''
            ? this.formatDate(data.dateNaissanceAssure)
            : '',
        dateNaissanceConjoint:
          data.dateNaissanceConjoint != ''
            ? this.formatDate(data.dateNaissanceConjoint)
            : '',
        enfant: {
          ...data.enfant,
          dateNaissanceEnfant:
            data.enfant.dateNaissanceEnfant.length > 0
              ? data.enfant.dateNaissanceEnfant.map((date) =>
                  this.formatDate(date),
                )
              : [],
          nombreEnfants: data.enfant.dateNaissanceEnfant.length,
        },
      };

      this.setQuestionValue(
        'NiveauRemboursement',
        'Medicaux' +
          this.personne.niveauRemboursement.soinsMedicaux +
          ';' +
          'Hospi' +
          this.personne.niveauRemboursement.hospi +
          ';' +
          'Dentaire' +
          this.personne.niveauRemboursement.dentaire +
          ';' +
          'Optique' +
          this.personne.niveauRemboursement.optique +
          ';' +
          'Audit' +
          this.personne.niveauRemboursement.auditive +
          ';',
      );
      this.displayBtnQ0 = true;
      this.displayBtnQ1 = true;
      this.displayBtnQRS = true;
      this.setQuestionValue(
        'CompositionFamiliale',
        this.personne.compositionFamiliale,
      );
      this.setQuestionValue('Sexe', this.personne.sexe);
      this.setQuestionValue('RegimeSocial', this.personne.regimeSocial);
      this.dateNaissanceEnfant().clear();
      this.getDatenaissanceinputValue();
      var dateformat = this.personne.dateDebutContrat.replace(/\//g, '');
      this.setDateF('DateEffet', dateformat);
    }

    //Init:
    this.initialize(
      this.personne.nom,
      this.personne.prenom,
      this.personne.sexe,
      this.personne.compositionFamiliale,
      this.personne.dateNaissanceAssure,
      this.personne.dateNaissanceConjoint,
      this.personne.regimeSocial,
      this.personne.conjointRegimeSociale,
      this.personne.enfant,
      this.personne.dateDebutContrat,
      this.personne.niveauRemboursement,
      this.personne.telephone,
      this.personne.email,
      this.personne.codePostal,
      this.personne.etre_contacte_par_telephone,
    );

    await this.syncDataClientToPersonne();
    if (this.route.snapshot.queryParamMap.get('sante')) {
      let sante = this.route.snapshot.queryParamMap.get('sante');
      if (sante === '1' || sante === '2' || sante === '3' || sante === '4') {
        this.getCheckedValue('CompositionFamiliale', sante);
      }
    }

    this.isSlugOriginParam();
  }

  override ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges | any) {
    if (
      changes.formula &&
      this.package == PolicyModels.PackageEnum.Sante_Fidelity
    ) {
      this.patchBirthdayValidators(true);
    }
  }

  toggleBtnR() {
    this.displayBtnR = true;
  }

  toggleBtnQ0() {
    this.displayBtnQ0 = true;
  }

  toggleBtnQ1() {
    this.displayBtnQ1 = true;
  }

  toggleBtnQRS() {
    this.displayBtnQRS = true;
    this.displayBtnQRSC = true;
  }

  toggleBtnQDepuisEnfant() {
    this.displayBtnQRS = true;
    this.displayBtnQRSC = true;
  }

  addSlide() {
    this.slides.push(488);
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit(e: any) {
    //
  }

  breakpoint(e: any) {
    this.loggerService.log('breakpoint');
  }

  afterChange(e: any) {
    //
  }

  beforeChange(e: any) {
    //
  }

  async syncDataClientToPersonne(key: string | any = null, value: any = null) {
    let datasClientMTX = this.cookieService.get('datasClientMTX');

    if (datasClientMTX) {
      datasClientMTX = datasClientMTX.replace(/(%2B)/g, '+');
      datasClientMTX = datasClientMTX.replace(/(<script>.*<\/script>)/g, '');

      let tokenMtx = localStorage.getItem('mtx-token');
      if (tokenMtx) {
        let token: MtxDataLoginResponse = JSON.parse(tokenMtx);
        let exp: number = new Date(token.expiration).getTime();
        let date: number = new Date().getTime();

        const diffInMinutes = Math.floor((exp - date) / (1000 * 60));
        if (diffInMinutes < 10) {
          this.mtxApiService.getToken().subscribe((token) => {
            if (token && token.data && token.data.token) {
              localStorage.setItem('mtx-token', JSON.stringify(token.data));
            }
          });
        }
      } else {
        this.mtxApiService.getToken().subscribe((token) => {
          if (token && token.data && token.data.token) {
            localStorage.setItem('mtx-token', JSON.stringify(token.data));
          }
        });
      }

      let data: any = await this.mtxApiService.letDecrypt(datasClientMTX);
      if (data && data.request) {
        this.mtxApiService.saveDataClient(data.request);

        let dataCleinta = localStorage.getItem('dataCleint');
        if (dataCleinta) {
          let dataClientObject = JSON.parse(dataCleinta);

          this.personne.nom = dataClientObject.lastName;
          this.personne.prenom = dataClientObject.firstName;
          this.personne.email = dataClientObject.email;

          if (
            dataClientObject.mobilePhone &&
            dataClientObject.mobilePhone.length >= 10
          ) {
            this.personne.telephone = this.getPhoneNumberValidate(
              dataClientObject.mobilePhone,
            );
            this.phoneCtrl.setValue(this.personne.telephone);
            this.phoneCtrl.markAsTouched();
            this.phoneCtrl.markAsDirty();
            this.phoneCtrl.setErrors(null);
            this.phoneCtrl.updateValueAndValidity();
          }

          if (dataClientObject.mailingINSEE) {
            this.personne.codePostal = dataClientObject.mailingINSEE;
          }

          if (dataClientObject.mailingPostalCode) {
            this.personne.codePostal = dataClientObject.mailingPostalCode;
          }

          if (dataClientObject.dateOfBirth) {
            // format date of birth
            let reg = new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/g);
            let reg1 = new RegExp(/\d{2}\/\d{2}\/\d{4}/g);
            let reg2 = new RegExp(/\d{4}-\d{2}-\d{2}/g);

            if (reg.test(dataClientObject.dateOfBirth)) {
              let date = new Date(dataClientObject.dateOfBirth);
              let dateformated =
                DateTime.fromJSDate(date).toFormat('dd/LL/yyyy');
              this.personne.dateNaissanceAssure = dateformated;
            } else if (reg1.test(dataClientObject.dateOfBirth)) {
              this.personne.dateNaissanceAssure = dataClientObject.dateOfBirth;
            } else if (reg2.test(dataClientObject.dateOfBirth)) {
              let dateformated = DateTime.fromFormat(
                this.personne.dateNaissanceAssure,
                'yyyy-LL-dd',
              ).toFormat('dd/LL/yyyy');
              this.personne.dateNaissanceAssure = dateformated;
            } else {
              this.personne.dateNaissanceAssure = dataClientObject.dateOfBirth;
            }
          }

          if (dataClientObject['MT.Wazzari.sante']) {
            $.each(dataClientObject['MT.Wazzari.sante'], (k: string, v) => {
              let keyy = key;
              switch (k) {
                case 'CompositionFamiliale':
                  if (keyy && keyy == 'compositionFamiliale')
                    this.personne['compositionFamiliale'] = value;
                  else this.personne['compositionFamiliale'] = v;
                  this.displayBtnQ0 = true;

                  this.setQuestionValue(
                    'CompositionFamiliale',
                    this.personne['compositionFamiliale'],
                  );

                  break;
                case 'RegimeSocial':
                  this.personne['regimeSocial'] = v;
                  this.displayBtnQRS = true;
                  this.setQuestionValue('RegimeSocial', v);
                  break;
                case 'etre_contacte_par_telephone':
                  this.personne['etre_contacte_par_telephone'] = v;
                  if (v == true) {
                    this.quotationAcceptCompMT = '1';
                    localStorage.setItem('acceptCompMT', '1');
                  } else {
                    this.quotationAcceptCompMT = '0';
                    localStorage.setItem('acceptCompMT', '0');
                  }
                  break;

                case 'NiveauRemboursement':
                  this.personne['niveauRemboursement'] = v;
                  this.setQuestionValue(
                    'NiveauRemboursement',
                    'Medicaux' +
                      this.personne.niveauRemboursement.soinsMedicaux +
                      ';' +
                      'Hospi' +
                      this.personne.niveauRemboursement.hospi +
                      ';' +
                      'Dentaire' +
                      this.personne.niveauRemboursement.dentaire +
                      ';' +
                      'Optique' +
                      this.personne.niveauRemboursement.optique +
                      ';' +
                      'Audit' +
                      this.personne.niveauRemboursement.auditive +
                      ';',
                  );
                  this.f1(
                    'NiveauRemboursement',
                    'Medicaux' +
                      this.personne.niveauRemboursement.soinsMedicaux +
                      ';' +
                      'Hospi' +
                      this.personne.niveauRemboursement.hospi +
                      ';' +
                      'Dentaire' +
                      this.personne.niveauRemboursement.dentaire +
                      ';' +
                      'Optique' +
                      this.personne.niveauRemboursement.optique +
                      ';' +
                      'Audit' +
                      this.personne.niveauRemboursement.auditive +
                      ';',
                  );
                  break;

                default:
                  let kk = this.mtxApiService.capitalize(k);
                  this.setQuestionValue(kk, '' + this.personne[k]);

                  let ky = this.mtxApiService.uncapitalize(k);

                  if (ky == 'conjointRegimeSocial') {
                    ky = 'conjointRegimeSociale';
                    this.setQuestionValue(
                      'ConjointRegimeSocial',
                      '' + this.personne[ky],
                    );
                  }

                  if (value == '1') {
                    let notSync = [
                      'enfant',
                      'conjointRegimeSociale',
                      'dateNaissanceConjoint',
                    ];

                    if (!notSync.includes(ky)) {
                      this.personne[ky] = v;
                    }
                  } else if (value == '2') {
                    let notSync = [
                      'conjointRegimeSociale',
                      'dateNaissanceConjoint',
                    ];
                    if (!notSync.includes(ky)) {
                      this.personne[ky] = v;
                    }

                    if (this.personne['enfant']) {
                      this.dateNaissanceEnfant().clear();
                      $.each(
                        this.personne['enfant']['dateNaissanceEnfant'],
                        (t, h) => {
                          this.dateNaissanceEnfant().push(this.new_enfant(''));
                        },
                      );
                      this.show_enfantDateNaissance = true;
                    }
                  } else if (value == '3') {
                    let notSync = ['enfant'];

                    if (!notSync.includes(ky)) {
                      this.personne[ky] = v;
                    }

                    if (this.personne['conjointRegimeSociale']) {
                      this.displayBtnQRSC = true;
                    }
                  } else if (value == '4') {
                    let notSync: any = [];
                    if (!notSync.includes(ky)) {
                      this.personne[ky] = v;
                    }

                    if (this.personne['conjointRegimeSociale']) {
                      this.displayBtnQRSC = true;
                    }
                    if (this.personne['enfant']) {
                      this.dateNaissanceEnfant().clear();
                      $.each(
                        this.personne['enfant']['dateNaissanceEnfant'],
                        (t, h) => {
                          this.dateNaissanceEnfant().push(this.new_enfant(''));
                        },
                      );
                      this.show_enfantDateNaissance = true;
                    }
                  } else {
                    this.personne[ky] = v;
                  }
                  break;
              }
            });
          }

          if (dataClientObject.salutation) {
            this.personne.sexe =
              dataClientObject.salutation == 'M.' ? '2' : '1';
            this.displayBtnQ1 = true;
          }

          if (key == 'compositionFamiliale') {
            this.personne.compositionFamiliale = value;
          }

          if (this.personne.enfant) {
            this.personne.enfant.nombreEnfants =
              this.personne.enfant.dateNaissanceEnfant.length;
          }

          this.initialize(
            this.personne.nom,
            this.personne.prenom,
            this.personne.sexe,
            this.personne.compositionFamiliale,
            this.personne.dateNaissanceAssure,
            this.personne.dateNaissanceConjoint,
            this.personne.regimeSocial,
            this.personne.conjointRegimeSociale,
            this.personne.enfant,
            this.personne.dateDebutContrat,
            this.personne.niveauRemboursement,
            this.personne.telephone,
            this.personne.email,
            this.personne.codePostal,
            this.personne.etre_contacte_par_telephone,
          );

          if (this.personne.niveauRemboursement) {
            this.setQuestionValue(
              'NiveauRemboursement',
              'Medicaux' +
                this.personne.niveauRemboursement.soinsMedicaux +
                ';' +
                'Hospi' +
                this.personne.niveauRemboursement.hospi +
                ';' +
                'Dentaire' +
                this.personne.niveauRemboursement.dentaire +
                ';' +
                'Optique' +
                this.personne.niveauRemboursement.optique +
                ';' +
                'Audit' +
                this.personne.niveauRemboursement.auditive +
                ';',
            );
          }

          if (
            (this.personne.compositionFamiliale == '2' ||
              this.personne.compositionFamiliale == '4') &&
            this.personne['enfant']
          ) {
            this.dateNaissanceEnfant().clear();
            $.each(this.personne['enfant']['dateNaissanceEnfant'], (t, h) => {
              this.dateNaissanceEnfant().push(this.new_enfant(''));
            });
            this.show_enfantDateNaissance = true;
          }

          if (this.personne.dateNaissanceConjoint) {
            this.setQuestionValue(
              'ConjointDateNaissance',
              '' + this.personne.dateNaissanceConjoint,
            );
          }
          if (this.personne.compositionFamiliale) {
            this.setQuestionValue(
              'CompositionFamiliale',
              '' + this.personne.compositionFamiliale,
            );
          }

          if (this.personne.sexe) {
            this.setQuestionValue('Sexe', '' + this.personne.sexe);
          }

          if (this.personne.dateNaissanceAssure) {
            this.setQuestionValue(
              'DateNaissance',
              '' + this.personne.dateNaissanceAssure,
            );
          }

          if (this.personne.regimeSocial) {
            this.setQuestionValue(
              'RegimeSocial',
              '' + this.personne.regimeSocial,
            );
          }

          if (this.personne.regimeSocial) {
            this.setQuestionValue(
              'ConjointRegimeSocial',
              '' + this.personne.conjointRegimeSociale,
            );
          }
          if (this.personne.dateDebutContrat) {
            this.setQuestionValue(
              'DateDebutContrat',
              '' + this.personne.dateDebutContrat,
            );
          }

          if (this.personne.nom && this.personne.prenom) {
            this.setQuestionValue(
              'NomPrenom',
              '' + this.personne.nom + ';' + this.personne.prenom,
            );
          }
          if (this.personne.codePostal) {
            this.setQuestionValue('Departement', '' + this.personne.codePostal);
          }

          if (this.personne.telephone && this.personne.email) {
            this.setQuestionValue(
              'Contact',
              '' + this.personne.telephone + ';' + this.personne.email,
            );
          }

          if (this.personne.enfant) {
            this.personne.enfant.nombreEnfants =
              this.personne.enfant.dateNaissanceEnfant.length;
            this.setQuestionValue(
              'NombreEnfants',
              '' + this.personne.enfant.nombreEnfants,
            );

            $.each(this.personne.enfant.dateNaissanceEnfant, (j, def) => {
              this.setQuestionValue('EnfantsDateNaissance', '' + def);
            });
          }

          if (this.personne.compositionFamiliale == '1') {
            this.displayBtnQRSC = false;
            this.show_enfantDateNaissance = false;
            this.show_conjointDateNaissnce = false;
            this.show_conjointRegimeSociale = false;
            this.personne.dateNaissanceConjoint = '';
            this.personne.conjointRegimeSociale = '';
            this.personne.enfant = new Enfant(0, []);
          } else if (this.personne.compositionFamiliale == '2') {
            this.displayBtnQRSC = false;
            this.show_conjointDateNaissnce = false;
            this.show_conjointRegimeSociale = false;
            this.personne.dateNaissanceConjoint = '';
            this.personne.conjointRegimeSociale = '';
          } else if (this.personne.compositionFamiliale == '3') {
            this.show_enfantDateNaissance = false;
            this.personne.enfant = new Enfant(0, []);
            this.displayBtnQRSC = true;
            this.show_conjointDateNaissnce = true;
            this.show_conjointRegimeSociale = true;
          } else if (this.personne.compositionFamiliale == '4') {
            this.displayBtnQRSC = true;
            this.show_enfantDateNaissance = true;
            this.show_conjointDateNaissnce = true;
            this.show_conjointRegimeSociale = true;
          }
          localStorage.setItem('app.personne', JSON.stringify(this.personne));
          //modify stored data
        }
      }
    }
  }

  getPhoneNumberValidate(phoneNumber: string) {
    if (!RegexConstants.AllPhone.test(phoneNumber)) {
      return '';
    }

    return (
      '0' + phoneNumber.substr(phoneNumber.length - 9, phoneNumber.length - 1)
    );
  }

  verifTunnelEtape(compositionFamiliale: any) {
    switch (compositionFamiliale) {
      case 1:
        return '9';
      case 2:
        return '10';
      case 3:
        return '12';
      case 4:
        return '12';
      default:
        return '';
    }
  }

  refreshTag(currentQuestion: number) {
    var tunnelEtape: any = this.verifTunnelEtape(
      this.personne.compositionFamiliale,
    );
    switch (currentQuestion) {
      case 0:
        this.taggingService.refresh(
          tunnelEtape,
          '1',
          'votre profil',
          'qui souhaitez-vous assurer ?',
          this.VisiteurId,
        );
        break;
      case 1:
        this.taggingService.refresh(
          tunnelEtape,
          '2',
          'votre profil',
          'vous etes ?',
          this.VisiteurId,
        );
        break;
      case 2:
        this.taggingService.refresh(
          tunnelEtape,
          '3',
          'votre profil',
          'quelle est votre date de naissance ?',
          this.VisiteurId,
        );
        break;
      case 3:
        this.taggingService.refresh(
          tunnelEtape,
          '4',
          'votre profil',
          'quel est votre régime social ?',
          this.VisiteurId,
        );
        break;
      case 4:
        if (this.personne.compositionFamiliale == '1') {
          this.taggingService.refresh(
            tunnelEtape,
            '5',
            'votre profil',
            'quand souhaitez-vous débuter votre contrat ?',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '2') {
          this.taggingService.refresh(
            tunnelEtape,
            '5',
            'votre profil',
            'dates de naissance de vos enfants ?',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '5',
            'votre profil',
            'quelle est la date de naissance de votre conjoint ?',
            this.VisiteurId,
          );
        }
        break;
      case 5:
        if (this.personne.compositionFamiliale == '1') {
          this.taggingService.refresh(
            tunnelEtape,
            '6',
            'votre profil',
            'quel est votre niveau de remboursement ?',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '2') {
          this.taggingService.refresh(
            tunnelEtape,
            '6',
            'votre profil',
            'quand souhaitez-vous débuter votre contrat ?',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '6',
            'votre profil',
            'quel est le régime social du conjoint ?',
            this.VisiteurId,
          );
        }
        break;
      case 6:
        if (this.personne.compositionFamiliale == '1') {
          this.taggingService.refresh(
            tunnelEtape,
            '7',
            'vos coordonnees',
            'dites-nous en plus sur vous ...',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '2') {
          this.taggingService.refresh(
            tunnelEtape,
            '7',
            'votre profil',
            'quel est votre niveau de remboursement ?',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '3') {
          this.taggingService.refresh(
            tunnelEtape,
            '7',
            'votre profil',
            'quand souhaitez-vous débuter votre contrat ?',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '7',
            'votre profil',
            'dates de naissance de vos enfants ?',
            this.VisiteurId,
          );
        }
        break;
      case 7:
        if (this.personne.compositionFamiliale == '1') {
          this.taggingService.refresh(
            tunnelEtape,
            '8',
            'vos coordonnees',
            'ou habitez-vous ?',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '2') {
          this.taggingService.refresh(
            tunnelEtape,
            '8',
            'vos coordonnees',
            'dites-nous en plus sur vous ...',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '3') {
          this.taggingService.refresh(
            tunnelEtape,
            '8',
            'votre profil',
            'quel est votre niveau de remboursement ?',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '8',
            'votre profil',
            'quand souhaitez-vous débuter votre contrat ?',
            this.VisiteurId,
          );
        }
        break;
      case 8:
        if (this.personne.compositionFamiliale == '1') {
          setTimeout(() => {
            this.taggingService.refresh(
              tunnelEtape,
              '9',
              'vos coordonnees',
              'comment vous contacter ?',
              this.VisiteurId,
            );
          }, 200);
        } else if (this.personne.compositionFamiliale == '2') {
          this.taggingService.refresh(
            tunnelEtape,
            '9',
            'vos coordonnees',
            'ou habitez-vous ?',
            this.VisiteurId,
          );
        } else if (this.personne.compositionFamiliale == '3') {
          this.taggingService.refresh(
            tunnelEtape,
            '9',
            'vos coordonnees',
            'dites-nous en plus sur vous ...',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '9',
            'votre profil',
            'quel est votre niveau de remboursement ?',
            this.VisiteurId,
          );
        }
        break;
      case 9:
        if (this.personne.compositionFamiliale == '2') {
          setTimeout(() => {
            this.taggingService.refresh(
              tunnelEtape,
              '10',
              'vos coordonnees',
              'comment vous contacter ?',
              this.VisiteurId,
            );
          }, 200);
        } else if (this.personne.compositionFamiliale == '3') {
          this.taggingService.refresh(
            tunnelEtape,
            '10',
            'vos coordonnees',
            'ou habitez-vous ?',
            this.VisiteurId,
          );
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '10',
            'vos coordonnees',
            'dites-nous en plus sur vous ...',
            this.VisiteurId,
          );
        }
        break;
      case 10:
        if (this.personne.compositionFamiliale == '3') {
          setTimeout(() => {
            this.taggingService.refresh(
              tunnelEtape,
              '11',
              'vos coordonnees',
              'comment vous contacter ?',
              this.VisiteurId,
            );
          }, 200);
        } else {
          this.taggingService.refresh(
            tunnelEtape,
            '11',
            'vos coordonnees',
            'ou habitez-vous ?',
            this.VisiteurId,
          );
        }
        break;
      case 11:
        setTimeout(() => {
          this.taggingService.refresh(
            tunnelEtape,
            '12',
            'vos coordonnees',
            'comment vous contacter ?',
            this.VisiteurId,
          );
        }, 200);
        break;
    }
    // if(currentQuestion == 2){
    //   window["tc_vars"] = {
    //     env_site: 'meilleurtaux santé',
    //     env_work: 'production',
    //     env_visiteur_id: 122,
    //     env_param: 'FIGARO',
    //     page_template: 'tunnel',
    //     page_tunnel: 'comparer les offres',
    //     tunnel_demande: 'comparaison des offres',
    //     tunnel_etape: tunnelEtape,// miampy anty
    //     tunnel_num_etape: '2', // miova
    //     tunnel_nom_etape: 'votre profil', //miova
    //     tunnel_nom_sous_etape: 'vous etes ?'// miova
    //   };
    //   window["tC"].event.page(this,{
    //     event_id: 'page',
    //     event_categorie: 'affichage tunnel etape',
    //     event_nom: 'votre profil – vous etes ?' // miova
    //   });
    // }
  }

  checkChild18(idChild: any) {
    if (!this.personne.enfant.dateNaissanceEnfant[idChild]) return false;
    var dateNaissance = new Date(
      this.personne.enfant.dateNaissanceEnfant[idChild].replace(
        /(\d+[/])(\d+[/])/,
        '$2$1',
      ),
    );
    var dateNow = new Date();
    var diff = dateNow.getTime() - dateNaissance.getTime();
    var diffYear = diff / (1000 * 3600 * 24 * 365);
    if (diffYear >= 18 && diffYear <= 26) {
      return true;
    } else {
      return false;
    }
  }

  childIs26: boolean = false;

  checkChildAny26() {
    var dateNow = new Date();
    var a = false;
    var dateNaissanceAssure = new Date(
      this.personne.dateNaissanceAssure.replace(/(\d+[/])(\d+[/])/, '$2$1'),
    );
    if (this.personne.enfant.dateNaissanceEnfant.length == 0) {
      a = true;
    }
    for (let i = 0; i < this.personne.enfant.dateNaissanceEnfant.length; i++) {
      if (
        !this.personne.enfant.dateNaissanceEnfant[i] ||
        (this.personne.enfant.dateNaissanceEnfant[i] &&
          this.personne.enfant.dateNaissanceEnfant[i].length != 10)
      ) {
        return true;
      }
      var dateNaissance = new Date(
        this.personne.enfant.dateNaissanceEnfant[i].replace(
          /(\d+[/])(\d+[/])/,
          '$2$1',
        ),
      );
      var diff = dateNow.getTime() - dateNaissance.getTime();
      var diffYear = diff / (1000 * 3600 * 24 * 365);
      var diff2 = dateNaissance.getTime() - dateNaissanceAssure.getTime();
      var diffYear2 = diff2 / (1000 * 3600 * 24 * 365);
      if (diffYear >= 26 || diffYear < 0 || diffYear2 < 0) {
        a = true;
      }
    }

    return a;
  }

  checkChild(idChild: any) {
    if (
      this.personne.enfant.dateNaissanceEnfant.length > 0 &&
      this.personne.enfant.dateNaissanceEnfant[idChild].length >= 10
    ) {
      var dateNaissance = new Date(
        this.personne.enfant.dateNaissanceEnfant[idChild].replace(
          /(\d+[/])(\d+[/])/,
          '$2$1',
        ),
      );
      var dateNow = new Date();

      let ctr: any = this.dateNaissanceEnfant().at(idChild);
      ctr.updateValueAndValidity();
      if (dateNaissance > dateNow) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private createFormGroup() {
    this.nomCtrl = this.fb.control(null, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.prenomCtrl = this.fb.control(null, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.dateDuJour = new Date();
    this.dateDuJourNaissance = new Date(
      this.dateDuJour.getFullYear() - 55,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.dateDuJourEffet = new Date(
      this.dateDuJour.getFullYear(),
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate() + 2,
    );
    this.dateNaissanceCtrl = this.fb.control('');
    this.regimeSocialCtrl = getControlWithValueChanges(
      this.fb,
      null,
      [Validators.required],
      (fc) => {
        this.regimeSocial.next(fc.value);
      },
      this.destroy$,
    );
    this.DateNaissanceMin = new Date(
      this.dateDuJour.getFullYear() - 90,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.formatDateNaissanceMin = formatDate(
      this.DateNaissanceMin,
      'dd/MM/yyyy',
    );
    this.DateNaissanceMax = new Date(
      this.dateDuJour.getFullYear() - 18,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.formatDateNaissanceMax = formatDate(
      this.DateNaissanceMax,
      'dd/MM/yyyy',
    );

    /*
    *  WzDateValidators.min(
        new Date(subYears(getDateUtc(), this.authService.isAdminImpersonated() ? 100 : 85).getFullYear(), 0, 1)
      )
    * */
    this.dateEffectCtrl = getControlWithValueChanges(
      this.fb,
      null,
      [
        Validators.required,
        WzDateValidators.min(this.getHealthEffectDateMin()),
        WzDateValidators.max(addYears(getDateUtc() ?? new Date(), 1)),
      ],
      (fc) => {
        this._dateEffet = null;
        if (fc.value) {
          this._dateEffet = getDateUtc(fc.value);
          this.dateEffet.next(getDateUtc(fc.value));
        } else {
          this.dateEffet.next(null);
        }
        this.patchBirthdayValidators();
        this.dateNaissanceCtrl.updateValueAndValidity();
      },
      this.destroy$,
    );

    this.dateNaissanceCtrl.setValue(
      formatDate(this.dateDuJourNaissance, 'dd/MM/yyyy'),
    );
    this.dateEffectCtrl.setValue(
      formatDate(this.dateDuJourEffet, 'dd/MM/yyyy'),
    );
    this.regimeSocialCtrl.setValue(HealthModels.RegimeSocialEnum.General);
    this.phoneCtrl = this.fb.control(null, [
      Validators.required,
      Validators.pattern(RegexConstants.AllPhone),
      Validators.maxLength(13),
      Validators.minLength(10),
    ]);
    this.emailCtrl = this.fb.control(null, [
      Validators.required,
      this.EmailNotBrokerValidator.bind(this),
      Validators.pattern(RegexConstants.Mail),
    ]);
    this.codePostalCtrl = this.fb.control(
      null,
      Validators.pattern(RegexConstants.POSTAL_CODE),
    );

    const group = this.fb.group({
      dateNaissance: this.dateNaissanceCtrl,
      dateEffet: this.dateEffectCtrl,
      regimeSocial: this.regimeSocialCtrl,
      phone: this.phoneCtrl,
      email: this.emailCtrl,
      codePostal: this.codePostalCtrl,
      nom: this.nomCtrl,
      prenom: this.prenomCtrl,
    });

    // this.formGroup = this.fb.group(
    //     {
    //         name: "",
    //         dateNaissanceEnfant: this.fb.array([])
    //     }
    // )

    return group;
  }

  EmailNotBrokerValidator: ValidatorFn | any = (control: FormControl) => {
    return this._agencyDetails &&
      control.value &&
      (control.value.toLowerCase() ==
        this._agencyDetails.headOfAgency.email.toLowerCase() ||
        control.value.toLowerCase() ==
          this._agencyDetails.mainBroker.brokerEmail.toLowerCase())
      ? { mailBroker: true }
      : null;
  };

  private patchBirthdayValidators(doUpdate?: boolean) {
    const ages = getMinMaxAgeByPackage(this.package, this.formula);
    this.minAge = ages.minAge;
    this.maxAge = ages.maxAge;
    const validators = factoryAgeValidators(
      this._dateEffet,
      ages.minAge,
      ages.maxAge,
    );
    this.dateNaissanceCtrl.setValidators(validators);

    if (doUpdate) {
      this.dateNaissanceCtrl.updateValueAndValidity();
    }
  }

  override onPatchValue(
    _assure: HealthModels.Assure,
    opt: { formula: QuotationModels.FormulaEnum },
  ): void {
    this.formula = opt.formula;
    this.controlListeParam = this.controlListe;
  }

  private getHealthEffectDateMin(): Date {
    // if (this.authService.isAdminImpersonated())
    //     return addDays(getDateUtc(), -365);
    // else {
    //     const delta = (<any>this.authService.user).allowDateEffetInPast
    //         ? -(<any>this.authService.user).allowDateEffetInPastNbDays + 1
    //         : 1;
    //     return addDays(getDateUtc(), delta);
    // }
    return addDays(getDateUtc() ?? new Date(), 1);
  }

  public eval(id: any) {
    // var find_object = this.controlListe.find(x => x.Id == id);
    // this.key=find_object.Id;
    // let e = eval(a + 3);
    //let e = eval(find_object.KeyQ);
    //  let e = eval(find_object.DateNaissanceMax);
    // var resp = true;
    // resp=eval(afind_object.Branch=="Sante");
    //let e = eval("1==1");
    let e = eval("find_object.Branch=='Sante1'");
    return e;
  }

  public evalProduct(produit: any, question: any) {
    // var find_object = this.controlListe.find(x => x.Branch == produit && x.KeyQ == question);

    let e = eval('find_object.Label');
    return e;
  }

  //STEPPER
  goNextStep() {
    //Code
  }

  goNextStep2(keyQ: any, data: any = null) {
    //Code
    // this.curentQuestion=this.f1();
    // this.matHorizontalStepper.next();
    this.dateNatHasChanged = false;
    localStorage.removeItem('goBackDataClientwithenfant');
    this.f1(keyQ, data);
  }

  //Question value has value or not
  questionValueHasValue: boolean = false;
  value: string = '';

  goBack(keyQ: any, data: any = null, isBackIntoEnfant: any = false) {
    //Code
    // this.curentQuestion=this.f1();
    // this.matHorizontalStepper.next();

    //Refactorisation code pour bug sur regime sociaux
    // let dataCleint = localStorage.getItem("dataCleint");
    // let dataCleintPersonne = localStorage.getItem("data.client.personne");
    //Refactorisation code pour bug sur regime sociaux

    var resultObject = this.controlListe[keyQ - 1];

    if (
      this.personne &&
      this.personne.enfant &&
      this.personne.enfant.dateNaissanceEnfant.length > 0
    ) {
      $.each(
        this.personne.enfant.dateNaissanceEnfant,
        (idChild: any, ch: any) => {
          let formater = this.personne.enfant.dateNaissanceEnfant[idChild];
          let ctr: any = this.dateNaissanceEnfant().at(idChild);
          ctr.get('date_enfant').setValue(formater);
          ctr.updateValueAndValidity();
        },
      );
    }

    if (resultObject.CurentDisplayed == true) {
      localStorage.setItem('goBackDataClientwithenfant', '1');

      this.curentQuestion--;

      //Refactorisation code pour bug sur regime sociaux
      //   if(
      //     keyQ == 7 &&
      //     this.personne &&
      //     this.personne.enfant &&
      //     this.personne.enfant.dateNaissanceEnfant.length > 0 &&
      //     this.personne.dateNaissanceConjoint &&
      //     !isBackIntoEnfant &&
      //     (dataCleint || dataCleintPersonne)
      //   )
      //   {
      //     if(this.personne.compositionFamiliale == "4")
      //         this.curentQuestion++;
      //   }

      //   if(data && data.keystring == 'ConjointDateNaissance' && this.curentQuestion == 5)
      //   {

      //     if(!dataCleint ||!(dataCleintPersonne))
      //         this.curentQuestion--;

      //   }
      // }
      // else {
      //   //check affiche enfant
      //   let stepCheck = keyQ - 1;
      //   this.curentQuestion--;
      //   this.goBack(stepCheck);
      //Refactorisation code pour bug sur regime sociaux
    }
    // this.f1(keyQ--);

    //Check if controlListe.QuestionValue has value:
    //If it has value we gonna put value inside of formulaire devis (check, nom, prenom....)
    try {
      this.value = this.getQuestionValue(keyQ - 1);
      if (this.value == '' || this.value == '0') {
        this.questionValueHasValue = false;
      } else {
        this.questionValueHasValue = true;
      }
    } catch (Exception) {
      //throw new Error('Error getQuestion undifined!')
    }

    //Do tagging:
    this.refreshTag(this.curentQuestion);

    const tunnelElement = document.querySelector('body > wz-app-tunnel');
    if (tunnelElement) {
      tunnelElement.scrollTo(0, 0);
    }
  }

  goBackAndDeleteAll(keyQ: any) {
    this.enfant = new Enfant(0, []);
    this.niveauRemboursement = new NiveauRemboursement('', '', '', '', '');
    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
      localStorage.getItem('parrain') || '',
    );
    this.goBack(keyQ);
  }

  goPreviousStep() {}

  regimeSocialSelect(regime: any) {
    this.regimeSocial = regime;
  }

  //"#CompositionFamiliale# == 3 || #CompositionFamiliale# == 4"

  f1(keyQ: any, data: any = null) {
    //Refactorisation code pour bug sur regime sociaux
    // let dataCleint = localStorage.getItem("dataCleint");
    // let dataPersonne = localStorage.getItem('data.client.personne');
    // if(
    //     keyQ == 1 && this.personne
    //     && this.personne.dateNaissanceAssure
    //     && dataCleint
    // )
    // {
    //     if(this.curentQuestion == 1 && this.personne.compositionFamiliale != "2" && this.personne.compositionFamiliale != "4")
    //         this.curentQuestion = 2;
    // }
    // if( keyQ == 2 && this.personne && this.personne.enfant.nombreEnfants ==0 && dataPersonne){
    //     this.curentQuestion++;
    // }
    // var result = this.controlListe[this.curentQuestion + 1].DisplayCondition;
    //Refactorisation code pour bug sur regime sociaux

    // var replaced = result.replace("#CompositionFamiliale#", this.getQuestionValue("CompositionFamiliale"));

    // var result = this.getQuestion(keyQ).DisplayCondition;

    //Refactorisation code pour bug sur regime sociaux
    // const search = '#CompositionFamiliale#';
    // const replaceWith = this.getQuestionValue('CompositionFamiliale');
    // const replaced = result.split(search).join(replaceWith);

    // var result2 = eval(replaced);

    // var find_object = this.controlListe[this.curentQuestion + 1];

    // if (result2 == true) {
    //   find_object.CurentDisplayed = true;
    //   this.curentQuestion++;

    //   if (data && data.keystring == 'ConjointDateNaissance' && this.curentQuestion == 5) {

    //   }
    // } else {
    //   // this.curentQuestion++;

    //   find_object.CurentDisplayed = false;
    //     this.curentQuestion = this.curentQuestion + 2;
    //   if(!this.IsNullOrEmpty(this.personne.compositionFamiliale) && this.personne.compositionFamiliale =='3'){
    //     this.curentQuestion = this.curentQuestion + 1;
    //   }
    //   else{
    //     this.curentQuestion = this.curentQuestion + 2;
    //   }

    //     if(
    //         keyQ == 6 && this.personne
    //         && this.personne.enfant
    //         && this.personne.enfant.dateNaissanceEnfant.length > 0
    //         && (dataCleint || dataPersonne)
    //     )
    //     {
    //         if(this.curentQuestion == 8 && this.personne.compositionFamiliale == "4") this.curentQuestion = 7
    //     }

    //     if(
    //         keyQ == 4 && this.personne
    //         && this.personne.conjointRegimeSociale
    //         && (dataCleint || dataPersonne)
    //     )
    //     {
    //         if(this.curentQuestion == 6 && this.personne.compositionFamiliale == "3") this.curentQuestion = 5
    //     }

    //     if(
    //         keyQ == 1 && this.personne
    //         && this.personne.dateNaissanceAssure
    //         && (dataCleint || dataPersonne)
    //     )
    //     {
    //         if(this.curentQuestion == 3) this.curentQuestion = 2
    //     }

    //     if(
    //         keyQ == 5 && this.personne
    //         && this.personne.conjointRegimeSociale
    //         && this.personne.compositionFamiliale
    //         && this.personne.compositionFamiliale == "3"
    //         && (dataCleint || dataPersonne)
    //     )
    //     {
    //         if(this.curentQuestion == 7) this.curentQuestion = 6
    //     }
    // }
    //
    //Refactorisation code pour bug sur regime sociaux

    this.curentQuestion++;
    this.refreshTag(this.curentQuestion);
    //Store question order
    this.pageOrder.push(this.curentQuestion);
    // return result;
  }

  setQuestionValue(keyString: any, valeur: any) {
    var find_object = this.controlListe.find((x) => x.KeyQ == keyString);

    if (!find_object) return;

    if (
      keyString == 'DateNaissance' ||
      keyString == 'DateDebutContrat' ||
      keyString == 'ConjointDateNaissance'
    ) {
      if (valeur.search('/') == 2) {
        valeur = this.setDateFormat(valeur);
      }

      find_object.QuestionValue = valeur;
    }

    if (keyString == 'EnfantsDateNaissance') {
      if (valeur.search('/') == 2) {
        valeur = this.setDateFormat(valeur);
      }
      find_object.QuestionValue += valeur + ';';
    } else {
      find_object.QuestionValue = valeur;
    }
  }

  getQuestionValue(keyString: any) {
    var find_object: any = this.controlListe.find((x) => x.KeyQ == keyString);
    return find_object.QuestionValue;
  }

  getQuestion(keyString: any) {
    var find_object: any = this.controlListe.find((x) => x.KeyQ == keyString);
    return find_object;
  }

  //Enable bouton Suivant:
  compositionFamiliale_unchecked: boolean = true;

  set_bouton_suivant_enabled(): void {
    this.compositionFamiliale_unchecked = false;
  }

  async getInputNomPrenomValue(keystring: string, nom: string, prenom: string) {
    //Store input data on variable personne
    this.personne.nom = nom;
    this.personne.prenom = prenom;

    const assurePrincipal = {
      Nom: nom,
      Prenom: prenom,
    };
    this.loading = true;

    var response = await this.healthQuotationApiService
      .checkFraudeurPersonByName(assurePrincipal)
      .toPromise();

    if (response && response == true) {
      //Blacklisté : afficher popup :
      this.fraudeModalService.openDialog('', '');
    } else {
      //Go to next step
      this.setQuestionValue(keystring, nom + ';' + prenom);
      if (this.personne.nom != '' && this.personne.prenom != '') {
        this.goNextStep2(this.curentQuestion);
      }
    }
    this.loading = false;
  }

  //Marche pour tout les dates
  getInputDate(keystring: string, date: string) {
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    //Store input data on variable personne
    if (keystring == 'DateNaissance') {
      this.personne.dateNaissanceAssure = date;
      if (window['tC']) {
        let jsonData: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question:
            'votre profil – quelle est votre date de naissance ?',
          event_tunnel_reponse:
            this.calcAge(this.personne.dateNaissanceAssure) + ' ans',
        };

        if (age >= 0) {
          jsonData['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, jsonData);
      }
    }
    if (keystring == 'ConjointDateNaissance') {
      this.personne.dateNaissanceConjoint = date;
      if (window['tC']) {
        let jsonData: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question:
            'profil du conjoint – quelle est la date de naissance de votre conjoint ?',
          event_tunnel_reponse:
            this.calcAge(this.personne.dateNaissanceConjoint) + ' ans',
        };

        if (age >= 0) {
          jsonData['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, jsonData);
      }
    }
    if (keystring == 'DateDebutContrat') {
      this.personne.dateDebutContrat = date;
      if (window['tC']) {
        let jsonData: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question:
            'votre profil – quand souhaitez-vous débuter votre contrat ?',
          event_tunnel_reponse: this.personne.dateDebutContrat,
        };

        if (age >= 0) {
          jsonData['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, jsonData);
      }
    }
    this.setQuestionValue(keystring, date);
    this.goNextStep2(this.curentQuestion, { keystring: keystring });
  }

  //composition familiale
  async getCheckedValue(keystring: string, inputValue: string) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataPersonne = localStorage.getItem('data.client.personne');
    this.personne.codeParrain = localStorage.getItem('parrain') || '';

    if (keystring == 'CompositionFamiliale') {
      let initialValue = this.personne.compositionFamiliale;
      if (initialValue != inputValue) {
        //Reinitialiser Model Personne and Reset data in session storage
        sessionStorage.removeItem('app.personne');
        // sessionStorage.removeItem('gclid');
        sessionStorage.removeItem('app.isFromPage2');
        sessionStorage.removeItem('tokenData');

        this.personne = new Personne(
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          new Enfant(0, []),
          '',
          new NiveauRemboursement('', '', '', '', ''),
          '',
          '',
          '',
          false,
          localStorage.getItem('parrain') || '',
        );

        this.personne.compositionFamiliale = inputValue; // 1 = Celibataire, 2=Adulte avec Enfant, 3=Couple, 4= Couple avec enfant
        this.displayBtnQ0 = false;
        this.displayBtnQ1 = false;
        this.displayBtnQRS = false;
        this.displayBtnQRSC = false;
        this.personne.codeParrain = localStorage.getItem('parrain') || '';

        if (dataClient) {
          // update dataClient
          let data: any = JSON.parse(dataClient);
          if (data) {
            data['MT.Wazzari.sante'] = {
              ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
              CompositionFamiliale: inputValue,
              compositionFamiliale: inputValue,
            };

            let dataCleinta: string = JSON.stringify(data);
            dataCleinta = dataCleinta.replace(/(<script>.*<\/script>)/g, '');
            localStorage.setItem('dataCleint', dataCleinta);

            if (dataCleinta) {
              let data1: any = await this.mtxApiService.letEncrypt(
                JSON.parse(dataCleinta),
              );
              if (data1 && data1.request && data1.request.encrypt) {
                let expireIn: Date = new Date();
                expireIn.setFullYear(expireIn.getFullYear() + 1);
                // updateCookies
                let options: CookieOptions = {
                  domain: environment.domainMTX, // change if deploi
                  path: '/',
                  httpOnly: false,
                  sameSite: 'none',
                  secure: true,
                  expires: expireIn,
                };
                this.cookieService.put(
                  'datasClientMTX',
                  data1.request.encrypt,
                  options,
                );
              }
            }
          }
        }
      } else {
        this.personne.compositionFamiliale = inputValue;
      }

      await this.syncDataClientToPersonne('compositionFamiliale', inputValue);
    }
    let age = this.calcAge(this.personne.dateNaissanceAssure);

    if (keystring == 'ConjointRegimeSocial') {
      this.personne.conjointRegimeSociale = inputValue;

      if (dataClient) {
        // update dataClient
        let data: any = JSON.parse(dataClient);
        if (data) {
          data['MT.Wazzari.sante'] = {
            ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
            ConjointRegimeSocial: inputValue,
            conjointRegimeSocial: inputValue,
          };

          this.mtxApiService.updateDataClient(data);
        }
      }
      if (dataPersonne) {
        let dataClientPersonne = JSON.parse(dataPersonne);
        if (dataClientPersonne) {
          dataClientPersonne['conjointRegimeSociale'] =
            this.personne.conjointRegimeSociale;
          this.mtxApiService.saveDataClientPersonne(
            'data.client.personne',
            dataClientPersonne,
          );
        }
      }
      if (window['tC']) {
        let datatc: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question:
            'profil du conjoint – quel est le régime social du conjoint ?',
          event_tunnel_reponse: this.personne.conjointRegimeSociale,
        };

        if (age >= 0) {
          datatc['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, datatc);
      }
    }
    if (keystring == 'Sexe') {
      this.personne.sexe = inputValue;

      if (window['tC']) {
        let datatc: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question: 'votre profil – vous etes ?',
          event_tunnel_reponse: this.personne.sexe,
        };

        if (age >= 0) {
          datatc['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, datatc);
      }

      if (dataClient) {
        // update dataClient
        let data: any = JSON.parse(dataClient);
        if (data) {
          data['salutation'] = inputValue == '2' ? 'M.' : 'Mme';
          data['MT.Wazzari.sante'] = {
            ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
            Sexe: inputValue,
            sexe: inputValue,
          };

          this.mtxApiService.updateDataClient(data);
        }
      }
      if (dataPersonne) {
        let dataClientPersonne = JSON.parse(dataPersonne);
        if (dataClientPersonne) {
          dataClientPersonne['sexe'] = inputValue;
          this.mtxApiService.saveDataClientPersonne(
            'data.client.personne',
            dataClientPersonne,
          );
        }
      }
    }
    if (keystring == 'RegimeSocial') {
      this.personne.regimeSocial = inputValue;

      if (dataClient) {
        // update dataClient
        let data: any = JSON.parse(dataClient);
        if (data) {
          data['MT.Wazzari.sante'] = {
            ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
            regimeSocial: inputValue,
            RegimeSocial: inputValue,
          };

          this.mtxApiService.updateDataClient(data);
        }
      }
      if (dataPersonne) {
        let dataClientPersonne = JSON.parse(dataPersonne);
        if (dataClientPersonne) {
          dataClientPersonne['regimeSocial'] = inputValue;
          this.mtxApiService.saveDataClientPersonne(
            'data.client.personne',
            dataClientPersonne,
          );
        }
      }
      if (window['tC']) {
        let datatc: any = {
          event_id: 'action',
          event_categorie: 'tunnel reponse',
          event_nom: 'reponse question',
          event_tunnel: 'comparer les offres',
          event_tunnel_question:
            'votre profil – quel est votre régime social ?',
          event_tunnel_reponse: this.personne.regimeSocial,
        };

        if (age >= 0) {
          datatc['event_user_age'] = age + '';
          if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.action(this, datatc);
      }
    }

    this.setQuestionValue(keystring, inputValue);
    this.goNextStep2(this.curentQuestion);
  }

  changeFirstName(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['firstName'] = inputValue;
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          prenom: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['prenom'] = inputValue;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  changePostalCode(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        if (data['mailingINSEE']) data['mailingINSEE'] = inputValue;
        if (data['mailingPostalCode']) data['mailingPostalCode'] = inputValue;

        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          codePostal: inputValue,
          CodePostal: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['codePostal'] = inputValue;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  changeTelephone(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['mobilePhone'] = inputValue;

        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          telephone: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['telephone'] = inputValue;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  changeMail(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['email'] = inputValue;

        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          email: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['email'] = inputValue;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  changeName(event: any) {
    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    let inputValue = (event.target as HTMLInputElement).value;
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['lastName'] = inputValue;
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          nom: inputValue,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['nom'] = inputValue;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  //Niveau remboursement:
  getCheckedNiveauRemboursement(
    keystring: string,
    inputValue: string,
    niveau: string,
  ) {
    let value: string = inputValue.toLowerCase();
    let dataClient = localStorage.getItem('dataCleint');
    if (value.includes('hospi')) {
      this.personne.niveauRemboursement.hospi = niveau;
    }
    if (value.includes('medicaux')) {
      this.personne.niveauRemboursement.soinsMedicaux = niveau;
    }
    if (value.includes('dentaire')) {
      this.personne.niveauRemboursement.dentaire = niveau;
    }
    if (value.includes('optique')) {
      this.personne.niveauRemboursement.optique = niveau;
    }
    if (value.includes('audit')) {
      this.personne.niveauRemboursement.auditive = niveau;
    }

    this.setQuestionValue(
      keystring,
      'Medicaux' +
        this.personne.niveauRemboursement.soinsMedicaux +
        ';' +
        'Hospi' +
        this.personne.niveauRemboursement.hospi +
        ';' +
        'Dentaire' +
        this.personne.niveauRemboursement.dentaire +
        ';' +
        'Optique' +
        this.personne.niveauRemboursement.optique +
        ';' +
        'Audit' +
        this.personne.niveauRemboursement.auditive +
        ';',
    );

    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          niveauRemboursement: this.personne.niveauRemboursement,
        };
        this.mtxApiService.updateDataClient(data);
      }
    }
  }

  subscription: Subscription = new Subscription();

  errorMessage: any;
  telephoneInvalide() {
    //Numeros inexistants
    var validation = ValiderData.ValiderTelephone(this.personne.telephone);
    if (validation) this.errorMessage = validation;
    return validation;
  }

  //Emails invalides @test.fr
  emailInvalide(email: string): boolean {
    const value = email.toLowerCase();
    if (value.includes('@test')) {
      return true;
    } else {
      return false;
    }
  }
  getInputContact(keystring: string, telephone: string, email: string) {
    // this.risk.assure.address.cityZipCode = this.personne.codePostal;
    // this.risk.assure.address.codeInsee = this.personne.codePostal;
    // this.risk.assure.address.cityName = "Paris"

    //Pour le numéros internationales, +33, 33 et 0033  remplacer par 0
    if (
      telephone.startsWith('+33') ||
      telephone.startsWith('0033') ||
      telephone.startsWith('33')
    ) {
      telephone = '0' + telephone.substring(telephone.indexOf('33') + 2);
      this.personne.telephone = telephone;
    }

    this.loading = true;
    this.setQuestionValue(keystring, telephone + ';' + email);
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    if (window['tC']) {
      let datatc: any = {
        event_id: 'action',
        event_categorie: 'tunnel reponse',
        event_nom: 'reponse question',
        event_tunnel: 'comparer les offres',
        event_tunnel_question: 'vos coordonnees – comment vous contacter ?',
        event_telephone: telephone,
        event_email: email,
      };

      if (age >= 0) {
        datatc['event_user_age'] = age + '';
        if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
      }

      window['tC'].event.action(this, datatc);
    }
    this.setQuestionValue('Departement', this.personne.codePostal);

    if (this.personne.dateNaissanceAssure.search('/') == 2) {
      this.personne.dateNaissanceAssure = this.setDateFormat(
        this.personne.dateNaissanceAssure,
      );
    }
    if (this.personne.dateDebutContrat.search('/') == 2) {
      this.personne.dateDebutContrat = this.setDateFormat(
        this.personne.dateDebutContrat,
      );
    }
    if (this.personne.dateNaissanceConjoint.search('/') == 2) {
      this.personne.dateNaissanceConjoint = this.setDateFormat(
        this.personne.dateNaissanceConjoint,
      );
    }

    if (this.personne.enfant) {
      let arrayElement = this.personne.enfant.dateNaissanceEnfant;
      arrayElement.forEach((value: any, index: any) => {
        if (this.personne.enfant.dateNaissanceEnfant[index].search('/') == 2) {
          this.personne.enfant.dateNaissanceEnfant[index] = this.setDateFormat(
            this.personne.enfant.dateNaissanceEnfant[index],
          );
        }
      });
    }

    //Save data in SessionStorage, Personne Models
    sessionStorage.setItem('app.personne', JSON.stringify(this.personne));
    localStorage.setItem('data.client.personne', JSON.stringify(this.personne));
    //reset data in isFromPage2
    sessionStorage.removeItem('app.isFromPage2');
    sessionStorage.removeItem('tokenData');

    this.controlListeParam = this.controlListe;
    //document.getElementById('bouttonAllerTarifs').click();//Cette partie a été commentée car toutes les données envoyées sont maintenent dans SaveQuotation
    this.SaveQuotation();
  }

  //Display or not controll
  show_conjointDateNaissnce: boolean = false;
  show_conjointRegimeSociale: boolean = false;
  show_enfantDateNaissance: boolean = false;

  showView(keystring: string): any {
    switch (keystring) {
      case 'DateNaissance':
        if (this.curentQuestion == 2) {
          return true;
        }
        break;
      case 'RegimeSocial':
        if (this.curentQuestion == 3) {
          return true;
        }
        break;
      case 'ConjointDateNaissance':
        if (
          this.curentQuestion == 4 &&
          (this.personne.compositionFamiliale == '3' ||
            this.personne.compositionFamiliale == '4')
        ) {
          return true;
        }
        break;
      case 'ConjointRegimeSocial':
        if (
          this.curentQuestion == 5 &&
          (this.personne.compositionFamiliale == '3' ||
            this.personne.compositionFamiliale == '4')
        ) {
          return true;
        }
        break;
      case 'EnfantsDateNaissance':
        if (
          (this.curentQuestion == 6 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 4 &&
            this.personne.compositionFamiliale == '2')
        ) {
          return true;
        }
        break;
      case 'DateDebutContrat':
        if (
          (this.curentQuestion == 4 &&
            this.personne.compositionFamiliale == '1') ||
          (this.curentQuestion == 5 &&
            this.personne.compositionFamiliale == '2') ||
          (this.curentQuestion == 7 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 6 &&
            this.personne.compositionFamiliale == '3')
        ) {
          return true;
        }
        break;
      case 'NiveauRemboursement':
        if (
          (this.curentQuestion == 5 &&
            this.personne.compositionFamiliale == '1') ||
          (this.curentQuestion == 6 &&
            this.personne.compositionFamiliale == '2') ||
          (this.curentQuestion == 8 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 7 &&
            this.personne.compositionFamiliale == '3')
        ) {
          return true;
        }
        break;
      case 'NomPrenom':
        if (
          (this.curentQuestion == 6 &&
            this.personne.compositionFamiliale == '1') ||
          (this.curentQuestion == 7 &&
            this.personne.compositionFamiliale == '2') ||
          (this.curentQuestion == 9 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 8 &&
            this.personne.compositionFamiliale == '3')
        ) {
          return true;
        }
        break;
      case 'Departement':
        //Ou habitez vous:
        if (
          (this.curentQuestion == 7 &&
            this.personne.compositionFamiliale == '1') ||
          (this.curentQuestion == 8 &&
            this.personne.compositionFamiliale == '2') ||
          (this.curentQuestion == 10 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 9 &&
            this.personne.compositionFamiliale == '3')
        ) {
          return true;
        }
        break;
      case 'Contact':
        if (
          (this.curentQuestion == 8 &&
            this.personne.compositionFamiliale == '1') ||
          (this.curentQuestion == 9 &&
            this.personne.compositionFamiliale == '2') ||
          (this.curentQuestion == 11 &&
            this.personne.compositionFamiliale == '4') ||
          (this.curentQuestion == 10 &&
            this.personne.compositionFamiliale == '3')
        ) {
          return true;
        }
        break;
      default:
        return false;
    }
  }

  //Ajouter enfants
  //Ajouter enfants
  limiteEnfants_message: string = '';
  inputNumber: number = 1;

  //Date naissance Enfant Validator
  dateNaissanceEnfantControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(10),
  ]);

  //Update dateNaissanceEnfant modele
  showError: string = '';

  //Date pattern:
  datePattern: string =
    '(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))';

  datePatternEnfant: RegExp = /\d{2}\/\d{2}\/\d{4}/g;

  dateNaissanceEnfant() {
    return this.dateNaissanceEnfantForm.get('dateNaissanceEnfant') as FormArray;
  }

  new_enfant(date: string) {
    return this.formBuilder.group({
      date_enfant: new FormControl(date, [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern(this.datePatternEnfant),
      ]),
    });
  }

  add_enfant() {
    this.dateNaissanceEnfant().push(this.new_enfant(''));

    this.inputNumber += 1;
    if (this.inputNumber > 6) {
      //
    }
  }

  remove_enfant(i: number) {
    //this.personne.enfant.dateNaissanceEnfant[i] = ""; //remove value on table model
    //remove input element
    if (i > 0) {
      //i>0 we can't remove the first element
      this.dateNaissanceEnfant().removeAt(i);
      let elementToremove = this.personne.enfant.dateNaissanceEnfant[i]; //remove element in model personne
      this.remove_element_from_array(elementToremove);
      this.personne.enfant.dateNaissanceEnfant;

      this.inputNumber -= 1;

      let dataClient = localStorage.getItem('dataCleint');
      if (dataClient) {
        // update dataClient
        let data: any = JSON.parse(dataClient);
        if (data) {
          data['MT.Wazzari.sante'] = {
            ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
            enfant: this.personne.enfant,
          };

          this.mtxApiService.updateDataClient(data);
        }
      }
    }
  }

  remove_element_from_array(elementToremove: string): any {
    let arrayElement = this.personne.enfant.dateNaissanceEnfant;
    arrayElement.forEach((value: any, index: any) => {
      if (value == elementToremove) arrayElement.splice(index, 1);
    });
  }

  getInputDateNaissanceEnfants(keyString: string) {
    let size = this.personne.enfant.dateNaissanceEnfant.length;
    // var reponseTunnelTagEnfant = "";
    var find_object: any = this.controlListe.find((x) => x.KeyQ == keyString);
    find_object.QuestionValue = '';
    for (let i = 0; i < size; i++) {
      let value = this.personne.enfant.dateNaissanceEnfant[i];
      if (value != '' && value.length == 10) {
        this.setQuestionValue(
          keyString,
          this.personne.enfant.dateNaissanceEnfant[i],
        );
        //Set nombre enfant model
        // this.personne.enfant.nombreEnfants += 1;
        // reponseTunnelTagEnfant += "event_tunnel_reponse_enfant_"+i+":"+this.calcAge(this.personne.enfant.dateNaissanceEnfant[i]) + ",";
      }
    }
    // if(window["tC"]){
    // window["tC"].event.action(this,{'event_id': 'action','event_categorie': 'tunnel reponse','event_nom': 'reponse question','event_tunnel':'comparer les offres','event_tunnel_question': 'votre profil – dates de naissance de vos enfants ?','event_tunnel_reponse': this.personne.enfant.dateNaissanceEnfant });}

    this.goNextStep2(this.curentQuestion);
  }

  quotationForm!: HealthModels.QuotationForm;
  quotationParamOrigin!: string | null | undefined;
  quotationCodeOrigin!: string | null | undefined;
  quotationCodeParrain!: string | null | undefined;
  quotationNavigator!: QuotationModels.Navigator | null | undefined;
  quotationAcceptCompMT: string | null | undefined = '0';
  quotationBaseOrigin: string | null | undefined = null;

  brokerFees!: any;

  initialize(
    nom: string,
    prenom: string,
    sexe: string,
    compositionFamiliale: string,
    dateNaissanceAssure: string,
    dateNaissanceConjoint: string,
    regimeSocial: string,
    conjointRegimeSociale: string,
    enfant: Enfant,
    dateDebutContrat: string,
    niveauRemboursement: NiveauRemboursement,
    telephone: string,
    email: string,
    codePostal: string,
    etre_contacte_par_telephone: boolean,
  ) {
    const Addresse = {
      streetName: 'Les Bosquets de Chambéry',
      streetNumber: 12,
      streetType: 'Lotissement',
      repetition: 'string',
      complement: 'string',
      cityName: 'Ivry-sur-Seine',
      cityZipCode: codePostal,
      codeInsee: '94041',
    };
    var gcliTemp = '';
    if (
      this.gclid &&
      this.gclid != 'EAIaIQobChMI_PylqPrF9wIVQ7TVCh3X3A93EAAYASAAEgL03_D_BwE'
    ) {
      gcliTemp = this.gclid;
    }
    var msclkidTemp = '';
    if (this.msclkid) {
      msclkidTemp = this.msclkid;
    }

    //Dans IGD Homme = 1 et femme=2
    var sexeValue: number = 1;
    if (!this.IsNullOrEmpty(sexe)) {
      if (sexe == '1') sexeValue = 2;
      else sexeValue = 1;
    }

    var regimeValue: number = 0;
    if (!this.IsNullOrEmpty(regimeSocial)) {
      regimeValue = parseInt(regimeSocial);
    }

    const infos: CommonRiskModels.AssureInfos = {
      civilite: sexeValue, //Conforme à IGD
      nom: nom,
      prenom: prenom,
      address: Addresse,
      email: email,
      phone: telephone,
      mobile: telephone,
      immatriculation: '4511211',
      birthPlace: 'Paris ',
      birthCountry: 'France',
      doAgreeToReceiveInfosByEmail: false,
      isPoliticallyExposed: false,
      isEntournagePoliticallyExposed: false,
      doCertify: false,
    };

    const groupeville = {
      codePostal: codePostal,
      ville: 'Ivry-sur-Seine',
      inseeCode: '94041',
    };
    const assurePrincipal: HealthModels.Assure = {
      groupVille: groupeville,
      dateNaissance: dateNaissanceAssure,
      dateEffet: dateDebutContrat,
      regimeSocial: regimeValue,
    };

    //Niveau besoins:
    const universBesoinInfo: HealthModels.UniversBesoinInfo = {
      formula: QuotationModels.FormulaEnum.Sante2,
      hasAlreadyHealthContract: false,
      healthContractName: 'Axa',
      monthlyBudget: 100,
      questions: [
        {
          type: HealthModels.UniversBesoinTypeEnum.Auditif,
          level: this.NiveauRemboursementConverter(
            niveauRemboursement.auditive,
          ),
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.Dentaire,
          level: this.NiveauRemboursementConverter(
            niveauRemboursement.dentaire,
          ),
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.Hospitalisation,
          level: this.NiveauRemboursementConverter(niveauRemboursement.hospi),
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.Medecine,
          level: this.NiveauRemboursementConverter(
            niveauRemboursement.soinsMedicaux,
          ),
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.Optique,
          level: this.NiveauRemboursementConverter(niveauRemboursement.optique),
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.Pharmacie,
          level: HealthModels.UniversBesoinLevelEnum.Low,
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.BienEtre,
          level: HealthModels.UniversBesoinLevelEnum.Low,
        },
        {
          type: HealthModels.UniversBesoinTypeEnum.AvantageCapitalDC,
          level: HealthModels.UniversBesoinLevelEnum.Low,
        },
      ],
    };

    //Conjoint
    var conjoint: HealthModels.FamilyPerson | null = null;
    if (!this.IsNullOrEmpty(conjointRegimeSociale)) {
      //il y a un conjoint
      conjoint = {
        dateNaissance: dateNaissanceConjoint,
        regimeSocial: parseInt(conjointRegimeSociale),
        isRegimeSocialDifferent: false,
        isDisabled: false,
      };
    }
    //Enfants
    var enfants = [];
    if (enfant.dateNaissanceEnfant.length != 0) {
      //il y a des enfants
      for (let item of enfant.dateNaissanceEnfant) {
        var enfantItem = {
          dateNaissance: item,
          regimeSocial: parseInt(regimeSocial),
          isRegimeSocialDifferent: false,
          isDisabled: false,
        };
        //Add enfant
        enfants.push(enfantItem);
      }
    }
    const family: HealthModels.Family = {
      conjoint: conjoint!,
      enfants: enfants,
    };

    //Set all values on quotationForm
    this.quotationForm = {
      assureInfos: infos,
      assurePrincipal: assurePrincipal,
      family: family,
      universBesoinInfo: universBesoinInfo,
      vadInfo: {
        isVad: true,
        saleType: HealthModels.SaleTypeEnum.Remote,
        isCallFromProspect: false,
        isRappel: etre_contacte_par_telephone,
        isBloctel: false,
        toggleBloctel: false,
        toggleVad: false,
        tarifier: 'oui_Init',
        gclid: gcliTemp,
        msclkid: msclkidTemp,
      },
    };

    // debugger; // utile
    let paramOrigin = localStorage.getItem('paramOrigin');
    let parrain = localStorage.getItem('parrain');

    this.quotationParamOrigin = undefined;
    if (paramOrigin) this.quotationParamOrigin = paramOrigin;

    let codeOrigin = localStorage.getItem('codeOrigin');

    this.quotationCodeOrigin = undefined;
    if (codeOrigin) this.quotationCodeOrigin = codeOrigin;

    this.quotationCodeParrain = undefined;
    if (parrain) this.quotationCodeParrain = parrain;

    let baseOrigin = localStorage.getItem('baseOrigin');

    this.quotationBaseOrigin = undefined;
    if (baseOrigin) this.quotationBaseOrigin = baseOrigin;

    this.quotationAcceptCompMT = '0';
    let acceptCompMT = localStorage.getItem('acceptCompMT');
    if (acceptCompMT) this.quotationAcceptCompMT = acceptCompMT;

    this.brokerFees = {
      type: 12,
      healthRateLinear: 10,
      healthRateWithholding: 1,
      loading: 1,
      management: 1,
    };
  }

  //For string
  IsNullOrEmpty(value: any) {
    return value == null || value === '';
  }

  //We need to convert NiveauRemboursement to have the same as IGD
  NiveauRemboursementConverter(niveau: string): number {
    switch (niveau.toLowerCase()) {
      case 'aucun':
        return HealthModels.UniversBesoinLevelEnum.Low;
        break;
      case 'minimum':
        return HealthModels.UniversBesoinLevelEnum.Low;
        break;
      case 'moyen':
        return HealthModels.UniversBesoinLevelEnum.Medium;
        break;
      case 'fort':
        return HealthModels.UniversBesoinLevelEnum.High;
        break;
      case 'maximum':
        return HealthModels.UniversBesoinLevelEnum.VeryHigh;
      default:
        return 0; //Non renseigné
    }
  }

  @Output() submitEvent = new EventEmitter();

  SaveQuotation() {
    this.initialize(
      this.personne.nom,
      this.personne.prenom,
      this.personne.sexe,
      this.personne.compositionFamiliale,
      this.personne.dateNaissanceAssure,
      this.personne.dateNaissanceConjoint,
      this.personne.regimeSocial,
      this.personne.conjointRegimeSociale,
      this.personne.enfant,
      this.personne.dateDebutContrat,
      this.personne.niveauRemboursement,
      this.personne.telephone,
      this.personne.email,
      this.personne.codePostal,
      this.personne.etre_contacte_par_telephone,
    );

    const dataStoredQuotation: HealthModels.HealthQuotationStoredData = {
      quotationForm: this.quotationForm,
      brokerFees: this.brokerFees,
      controlListeParam: this.controlListe,
      formulaChoice: {
        formula: this.quotationForm.universBesoinInfo.formula,
        optionalWarranties: [],
      },
      quotationParamOrigin: this.quotationParamOrigin ?? undefined,
      quotationCodeOrigin: this.quotationCodeOrigin ?? undefined,
      quotationCodeParrain: this.quotationCodeParrain ?? undefined,
      quotationBaseOrigin: this.quotationBaseOrigin ?? undefined,
      quotationAcceptCompMT: this.quotationAcceptCompMT ?? undefined,
      currentStaggering: 1,
      package: this.healthInsuranceService.packageId,
      subscriptionForm: null,
      quotationNavigator: this.healthInsuranceService.getInfoNavigator(),
    };

    this.valider = true;
    //Execute receiveSubmit method on HealthquotationForm and HealthInsuranceQuotation
    this.submitEvent.emit(dataStoredQuotation);
  }

  focusEmail() {
    this.fMailError = true;
  }

  focusOutEmail() {
    this.fMailError = false;
  }

  restoreQuestionValue() {
    this.setQuestionValue(
      'CompositionFamiliale',
      this.personne.compositionFamiliale,
    );
    this.setQuestionValue('Sexe', this.personne.sexe);
    this.setQuestionValue('DateNaissance', this.personne.dateNaissanceAssure);
    this.setQuestionValue('RegimeSocial', this.personne.regimeSocial);
    this.setQuestionValue(
      'ConjointDateNaissance',
      this.personne.dateNaissanceConjoint,
    );
    this.setQuestionValue(
      'ConjointRegimeSocial',
      this.personne.conjointRegimeSociale,
    );
    this.setQuestionValue('DateDebutContrat', this.personne.dateDebutContrat);
    this.setQuestionValue(
      'NiveauRemboursement',
      'Medicaux' +
        this.personne.niveauRemboursement.soinsMedicaux +
        ';' +
        'Hospi' +
        this.personne.niveauRemboursement.hospi +
        ';' +
        'Dentaire' +
        this.personne.niveauRemboursement.dentaire +
        ';' +
        'Optique' +
        this.personne.niveauRemboursement.optique +
        ';' +
        'Audit' +
        this.personne.niveauRemboursement.auditive +
        ';',
    );
    this.setQuestionValue(
      'NomPrenom',
      this.personne.nom + ';' + this.personne.prenom,
    );
    this.setQuestionValue('Departement', this.personne.codePostal);
    this.setQuestionValue(
      'Contact',
      this.personne.telephone + ';' + this.personne.email,
    );
    var a = '';
    for (let i = 0; i < this.personne.enfant.dateNaissanceEnfant.length; i++) {
      a += this.personne.enfant.dateNaissanceEnfant[i] + ';';
    }
    this.setQuestionValue('EnfantsDateNaissance', a);
  }

  restoreData() {
    if (this.controlListe[0].QuestionValue != '0') {
      this.personne.compositionFamiliale = this.controlListe[0].QuestionValue;
      this.curentQuestion = 0;
    }
    if (this.controlListe[1].QuestionValue != '0') {
      this.personne.sexe = this.controlListe[1].QuestionValue;
      this.curentQuestion = 1;
    }
    if (this.controlListe[2].QuestionValue != '0') {
      //supprimer page nombre d'enfants
      this.personne.enfant.nombreEnfants = +this.controlListe[2].QuestionValue;
      this.curentQuestion = 2;
    }
    if (this.controlListe[3].QuestionValue != '0') {
      this.personne.dateNaissanceAssure = this.controlListe[3].QuestionValue;
      this.curentQuestion = 3;
    }
    if (this.controlListe[4].QuestionValue != '0') {
      this.personne.regimeSocial = this.controlListe[4].QuestionValue;
      this.curentQuestion = 4;
    }
    if (this.controlListe[5].QuestionValue != '0') {
      this.personne.dateNaissanceConjoint = this.controlListe[5].QuestionValue;
      this.curentQuestion = 5;
    }
    if (this.controlListe[6].QuestionValue != '0') {
      this.personne.conjointRegimeSociale = this.controlListe[6].QuestionValue;
      this.curentQuestion = 6;
    }
    if (this.controlListe[7].QuestionValue != '') {
      //enfant datenaiss
      var enfants = this.controlListe[7].QuestionValue.split(';');
      // this.personne.enfant.dateNaissanceEnfant = new String[enfants.length];
      for (let i = 0; i < enfants.length; i++) {
        this.personne.enfant.dateNaissanceEnfant[i] = enfants[i];
      }
      this.curentQuestion = 7;
    }
    if (this.controlListe[8].QuestionValue != '0') {
      this.personne.dateDebutContrat = this.controlListe[8].QuestionValue;
      this.curentQuestion = 8;
    }
    if (this.controlListe[9].QuestionValue != '') {
      //niveau r
      var niveauR = this.controlListe[9].QuestionValue.split(';');
      const filteredArray = niveauR.filter(function (ele, pos) {
        return niveauR.indexOf(ele) == pos;
      });
      for (let i = 0; i < filteredArray.length; i++) {
        if (filteredArray[i].includes('Medicaux')) {
          this.personne.niveauRemboursement.soinsMedicaux = filteredArray[i]
            .split('Medicaux')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Hospi')) {
          this.personne.niveauRemboursement.hospi = filteredArray[i]
            .split('Hospi')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Dentaire')) {
          this.personne.niveauRemboursement.dentaire = filteredArray[i]
            .split('Dentaire')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Optique')) {
          this.personne.niveauRemboursement.optique = filteredArray[i]
            .split('Optique')[1]
            .toLowerCase();
        }
        if (filteredArray[i].includes('Audit')) {
          this.personne.niveauRemboursement.auditive = filteredArray[i]
            .split('Audit')[1]
            .toLowerCase();
        }
      }
      this.curentQuestion = 9;
    }
    if (this.controlListe[10].QuestionValue != '0') {
      var nomPrenom = this.controlListe[10].QuestionValue.split(';');
      this.personne.nom = nomPrenom[0];
      this.personne.prenom = nomPrenom[1];
      this.curentQuestion = 10;
    }
    if (this.controlListe[11].QuestionValue != '0') {
      //departement
      // this.personne.compositionFamiliale = this.controlListe[11].QuestionValue;
      this.personne.codePostal = this.controlListe[11].QuestionValue;
      this.curentQuestion = 11;
    }
    if (this.controlListe[12].QuestionValue != '0') {
      //contact
      var contact = this.controlListe[12].QuestionValue.split(';');
      this.personne.telephone = contact[0];
      this.personne.email = contact[1];
      this.curentQuestion = 12;
    }
  }

  //Etre contacte
  onChangeInputEtreContacte(value: boolean) {
    this.personne.etre_contacte_par_telephone = value;
    this.quotationForm.vadInfo.isRappel = value;

    if (value == true) {
      this.quotationAcceptCompMT = '1';
      localStorage.setItem('acceptCompMT', '1');
    } else {
      this.quotationAcceptCompMT = '0';
      localStorage.setItem('acceptCompMT', '0');
    }

    let dataClient = localStorage.getItem('dataCleint');
    let dataClientPersonne = localStorage.getItem('data.client.personne');
    if (dataClientPersonne) {
      let dataPersonne: any = JSON.parse(dataClientPersonne);
      if (dataPersonne) {
        dataPersonne['etre_contacte_par_telephone'] = value;
        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }

    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          etre_contacte_par_telephone: value,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
  }

  dateNatHasChanged: boolean = false;
  dateEffetHasChanged: boolean = false;
  dateNatConjointHasChanged: boolean = false;

  CtrlDateNaissance!: Date;
  CtrlDateEffet!: Date;

  setDateF(keyString: any, valeur: any) {
    if (valeur.length == 8) {
      var dateStr = valeur;
      var day = +dateStr.substring(0, 2);
      var month = +dateStr.substring(2, 4);
      var year = +dateStr.substring(4, 8);

      const dt = DateTime.fromFormat(dateStr, 'ddMMyyyy', { locale: 'fr' });
      let datNat: Date;
      if (dt.isValid) {
        datNat = dt.toJSDate();
      } else {
        datNat = new Date(year, month - 1, day);
      }

      var formater = formatDate(datNat, 'dd/MM/yyyy');
      let dataClient = localStorage.getItem('dataCleint');

      if (keyString == 'DateNaissance') {
        this.personne.dateNaissanceAssure = formater;
        this.dateNaissanceCtrl.setValue(this.personne.dateNaissanceAssure);

        this.dateNatHasChanged = true;
        this.CtrlDateNaissance = new Date(
          this.dateNaissanceCtrl.value.replace(/(\d+[/])(\d+[/])/, '$2$1'),
        );
        if (dataClient) {
          // update dataClient
          let data: any = JSON.parse(dataClient);
          if (data) {
            data['dateOfBirth'] = formater;
            data['MT.Wazzari.sante'] = {
              ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
              dateNaissanceAssure: formater,
            };

            this.mtxApiService.updateDataClient(data);
          }
        }
      }
      if (keyString == 'DateNaissanceConjoint') {
        this.personne.dateNaissanceConjoint = formater;
        this.dateNaissanceCtrl.setValue(this.personne.dateNaissanceConjoint);
        this.dateNatConjointHasChanged = true;
        this.CtrlDateNaissance = new Date(
          this.dateNaissanceCtrl.value.replace(/(\d+[/])(\d+[/])/, '$2$1'),
        );
        if (dataClient) {
          // update dataClient
          let data: any = JSON.parse(dataClient);
          if (data) {
            data['MT.Wazzari.sante'] = {
              ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
              dateNaissanceConjoint: formater,
            };

            this.mtxApiService.updateDataClient(data);
          }
        }
      }

      if (keyString == 'DateEffet') {
        this.personne.dateDebutContrat = formater;
        this.dateEffectCtrl.setValue(this.personne.dateDebutContrat);
        this.dateEffetHasChanged = true;
        this.CtrlDateEffet = new Date(
          this.dateEffectCtrl.value.replace(/(\d+[/])(\d+[/])/, '$2$1'),
        );
        if (!this.healthEffectDateMin)
          this.healthEffectDateMin = this.getHealthEffectDateMin();
        this.healthEffectDateMin.setHours(0, 0, 0, 0);

        if (dataClient) {
          // update dataClient
          let data: any = JSON.parse(dataClient);
          if (data) {
            data['MT.Wazzari.sante'] = {
              ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
              dateDebutContrat: formater,
            };

            this.mtxApiService.updateDataClient(data);
          }
        }
        // if(dataClientPeronne) {
        //     let dataP : any = JSON.parse(dataClientPeronne);
        //     if(dataP){
        //         dataP["dateDebutContrat"] = formater;
        //         this.mtxApiService.saveDataClientPersonne('data.client.personne',dataP);
        //     }
        // }
      }
    }
  }

  setDateFormat(dateToFormat: string) {
    var day = dateToFormat.substring(0, 2);
    var month = dateToFormat.substring(3, 5);
    var year = dateToFormat.substring(6, 10);
    return year + '-' + month + '-' + day;
  }

  checkChild26(idChild: any) {
    if (!this.personne.enfant.dateNaissanceEnfant[idChild]) return false;
    var dateNaissance = new Date(
      this.personne.enfant.dateNaissanceEnfant[idChild].replace(
        /(\d+[/])(\d+[/])/,
        '$2$1',
      ),
    );
    var dateNow = new Date();
    var diff = dateNow.getTime() - dateNaissance.getTime();
    var diffYear = diff / (1000 * 3600 * 24 * 365);
    if (diffYear >= 26) {
      return true;
    } else {
      return false;
    }
  }

  setDateNatEnfant(valeur: any, idChild: any) {
    if (valeur.length < 8) return;
    var dateStr = valeur;
    var day = +dateStr.substring(0, 2);
    var month = +dateStr.substring(2, 4);
    var year = +dateStr.substring(4, 8);
    var datNat = new Date(year, month - 1, day);
    var formater = formatDate(datNat, 'dd/MM/yyyy');
    this.personne.enfant.dateNaissanceEnfant[idChild] = formater;

    let ctr: any = this.dateNaissanceEnfant().at(idChild);
    ctr.get('date_enfant').setValue(formater);
    ctr.updateValueAndValidity();

    this.dateNaissanceEnfantControl.updateValueAndValidity();

    let dataClient = localStorage.getItem('dataCleint');
    if (dataClient) {
      // update dataClient
      let data: any = JSON.parse(dataClient);
      if (data) {
        data['MT.Wazzari.sante'] = {
          ...(data['MT.Wazzari.sante'] ? data['MT.Wazzari.sante'] : {}),
          enfant: this.personne.enfant,
        };

        this.mtxApiService.updateDataClient(data);
      }
    }
    let dataClientPeronne = localStorage.getItem('data.client.personne');
    if (dataClientPeronne) {
      let dataPersonne: any = JSON.parse(dataClientPeronne);
      if (dataPersonne) {
        dataPersonne['enfant'] = this.personne.enfant;

        this.mtxApiService.saveDataClientPersonne(
          'data.client.personne',
          dataPersonne,
        );
      }
    }
  }

  setTagAdresse() {
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    this.showDiv = false;
    setTimeout(() => {
      this.showDiv = true;
    }, 200);
    if (window['tC']) {
      let datatc: any = {
        event_id: 'action',
        event_categorie: 'tunnel reponse',
        event_nom: 'reponse question',
        event_tunnel: 'comparer les offres',
        event_tunnel_question: 'vos coordonnees – ou habitez-vous ?',
        event_tunnel_reponse: this.personne.codePostal,
      };

      if (age >= 0) {
        datatc['event_user_age'] = age + '';
        if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
      }

      window['tC'].event.action(this, datatc);
    }
  }

  calcAge(dateNaissance: string) {
    let a = new Date().getTime();
    const formats = [
      'dd/MM/yyyy',
      'd/MM/yyyy',
      'dd/M/yyyy',
      'd/M/yyyy',
      'yyyy-MM-dd',
      'yyyy-MM-d',
      'yyyy-M-dd',
      'yyyy-M-d',
    ];

    let b: number = NaN;
    for (const format of formats) {
      const dt = DateTime.fromFormat(dateNaissance, format);
      if (dt.isValid) {
        b = dt.toJSDate().getTime();
        break;
      }
    }

    let timeDiff = Math.abs(a - b);
    let age = Math.round(timeDiff / (1000 * 3600 * 24) / 365.25);
    localStorage.setItem('AgeSouscripteur', age.toString());
    return age;
  }

  setTagNvRemb() {
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    if (
      window['tC'] &&
      this.personne.niveauRemboursement.soinsMedicaux.length > 0 &&
      this.personne.niveauRemboursement.hospi.length > 0 &&
      this.personne.niveauRemboursement.dentaire.length > 0 &&
      this.personne.niveauRemboursement.optique.length > 0 &&
      this.personne.niveauRemboursement.auditive.length > 0
    ) {
      let datatc: any = {
        event_id: 'action',
        event_categorie: 'tunnel reponse',
        event_nom: 'reponse question',
        event_tunnel: 'comparer les offres',
        event_tunnel_question:
          'vos besoins – niveau de remboursement souhaité ?',
        event_tunnel_reponse_soins:
          this.personne.niveauRemboursement.soinsMedicaux,
        event_tunnel_reponse_hospitalisation:
          this.personne.niveauRemboursement.hospi,
        event_tunnel_reponse_dentaire:
          this.personne.niveauRemboursement.dentaire,
        event_tunnel_reponse_optique: this.personne.niveauRemboursement.optique,
        event_tunnel_reponse_auditive:
          this.personne.niveauRemboursement.auditive,
      };

      if (age >= 0) {
        datatc['event_user_age'] = age + '';
        if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
      }

      window['tC'].event.action(this, datatc);
    }
  }
  digestMessage(message: any) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const hash = crypto.subtle.digest('SHA-256', data);
    return hash;
  }

  isSlugQuoteRequest() {
    let parameter_codeOrigin: any = localStorage.getItem('codeOrigin');
    let condition_headers = [
      'mutuellecom',
      'mutuelleonline',
      'Video',
      'afisante_affiliation',
      'mutuelleonline_affiliation',
      'labonnemutuelle_affiliation',
      'assuranceetmutuelle_affiliation',
      'Mutuelle.com_affiliation',
    ];
    if (condition_headers.includes(parameter_codeOrigin)) {
      $.default('body.height-auto-iframe').css('height', 'auto');
      return false;
    } else {
      $.default('body.height-auto-iframe').css('height', '100%');
      return true;
    }
  }
  isParrainLink() {
    let parameter_parrain = localStorage.getItem('parrain');
    let parameter_codeOrigin = localStorage.getItem('codeOrigin');

    this.civility_parrain = localStorage.getItem('civility_parrain');
    this.nom_parrain = localStorage.getItem('nom_parrain');
    this.prenoms_parrain = localStorage.getItem('prenoms_parrain');

    this.address1_parrain = localStorage.getItem('address1_parrain');
    this.postalcodeville = localStorage.getItem('postalcodeville');
    this.address2_parrain = localStorage.getItem('address2_parrain');

    if (
      (parameter_codeOrigin == 'parrainage_2024' ||
        parameter_codeOrigin == 'parrain') &&
      parameter_parrain
    ) {
      return true;
    }

    return false;
  }

  textShowInOriginAffiliation() {
    let parameter_codeOrigin_afisante_Affiliation =
      localStorage.getItem('codeOrigin');
    let parameter_paramOrigin_afisante_Affiliation =
      localStorage.getItem('paramOrigin');
    let condition_headers_afisante_Affiliation = [
      'afisante_affiliation',
      'afisante_SWM',
    ];
    return condition_headers_afisante_Affiliation.includes(
      parameter_codeOrigin_afisante_Affiliation +
        '_' +
        parameter_paramOrigin_afisante_Affiliation,
    );
  }

  verifyDateCreaEconomie(date1: string, date2: string): boolean {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    const dateToVerify: Date = new Date();
    const isBetween = dateToVerify >= startDate && dateToVerify <= endDate;
    return isBetween;
  }

  async preRemplirDataInput(key: string | null = null, value: any = null) {
    const dataPersonne = localStorage.getItem('data.client.personne');
    const formatDateStr = 'dd/LL/yyyy';
    if (dataPersonne) {
      let dataClientObject = JSON.parse(dataPersonne);
      let dateNaissanceStr = DateTime.fromFormat(
        dataClientObject.dateNaissanceAssure,
        'yyyy-LL-dd',
      ).toFormat(formatDateStr);
      // let dateEffetStr = DateTime.fromFormat(dataClientObject.dateDebutContrat, "yyyy-LL-dd").toFormat(formatDateStr);
      let dateNaissanceConjointStr = DateTime.fromFormat(
        dataClientObject.dateNaissanceConjoint,
        'yyyy-LL-dd',
      ).toFormat(formatDateStr);
      if (!this.IsNullOrEmpty(dataClientObject.dateNaissanceAssure)) {
        this.personne.dateNaissanceAssure = dateNaissanceStr;
      }
      // if(!this.IsNullOrEmpty(dataClientObject.dateDebutContrat)){
      this.personne.dateDebutContrat = '';
      // }
      this.personne.compositionFamiliale =
        dataClientObject.compositionFamiliale;
      if (!this.IsNullOrEmpty(this.personne.compositionFamiliale)) {
        this.toggleBtnQ0();
      }
      if (
        !this.IsNullOrEmpty(this.personne.compositionFamiliale) &&
        this.personne.compositionFamiliale === '3'
      ) {
        if (
          !this.IsNullOrEmpty(dateNaissanceConjointStr) &&
          dateNaissanceConjointStr != ''
        ) {
          if (!this.IsNullOrEmpty(this.personne.dateNaissanceAssure)) {
            this.toggleBtnQ1();
          }
          this.personne.dateNaissanceConjoint = dateNaissanceConjointStr;
          if (!this.IsNullOrEmpty(this.personne.dateNaissanceConjoint)) {
            this.toggleBtnQ0();
          }
          this.personne.conjointRegimeSociale =
            dataClientObject.conjointRegimeSociale;
          if (!this.IsNullOrEmpty(this.personne.conjointRegimeSociale)) {
            this.toggleBtnQRS();
          }
        }
      }
      this.personne.regimeSocial = dataClientObject.regimeSocial;
      if (!this.IsNullOrEmpty(this.personne.regimeSocial)) {
        this.toggleBtnQRS();
      }
      this.personne.sexe = dataClientObject.sexe;
      if (!this.IsNullOrEmpty(this.personne.sexe)) {
        this.toggleBtnQ1();
      }
      this.personne.nom = dataClientObject.nom;
      this.personne.prenom = dataClientObject.prenom;
      this.personne.email = dataClientObject.email;

      if (!this.IsNullOrEmpty(this.personne.dateDebutContrat)) {
        this.toggleBtnR();
      }

      this.personne.niveauRemboursement = dataClientObject.niveauRemboursement;
      if (this.personne.niveauRemboursement) {
        this.setQuestionValue(
          'NiveauRemboursement',
          'Medicaux' +
            this.personne.niveauRemboursement.soinsMedicaux +
            ';' +
            'Hospi' +
            this.personne.niveauRemboursement.hospi +
            ';' +
            'Dentaire' +
            this.personne.niveauRemboursement.dentaire +
            ';' +
            'Optique' +
            this.personne.niveauRemboursement.optique +
            ';' +
            'Audit' +
            this.personne.niveauRemboursement.auditive +
            ';',
        );
      }
      this.personne.codePostal = dataClientObject.codePostal;
      this.personne.telephone = dataClientObject.telephone;
      if (!this.IsNullOrEmpty(this.personne.codePostal)) {
        this.toggleBtnQ1();
      }
      this.personne.etre_contacte_par_telephone =
        dataClientObject.etre_contacte_par_telephone;
    }
  }

  InitNiveaudeRemboursementPrerempli() {}

  private updateDOM(
    expectedCode: string,
    containerClass: string,
    imgSrcs: {
      horloge?: string;
      soinsMedicaux?: string;
      ambulance?: string;
      dentaire?: string;
      optique?: string;
      audit?: string;
    },
  ) {
    const parameterCodeOrigin = localStorage.getItem('codeOrigin');
    if (parameterCodeOrigin === expectedCode) {
      setTimeout(() => {
        this.addClassToContainer(containerClass);
        this.addClassToElements('.choix .panel-heading', 'pathInAffiliation');

        const imgSelectors: any = {
          horloge: `.minute img`,
          soinsMedicaux: `.medicaux .choixTitre img`,
          ambulance: `.hospitalisation .choixTitre img`,
          dentaire: `.dentaire .choixTitre img`,
          optique: `.optique .choixTitre img`,
          audit: `.audit .choixTitre img`,
        };

        for (const [key, src] of Object.entries(imgSrcs)) {
          if (src) {
            this.updateImageSource(
              `.${containerClass} ${imgSelectors[key]}`,
              src,
            );
          }
        }
      }, 0);
    }
  }

  private addClassToContainer(containerClass: string) {
    const container = document.querySelector('#margin24') as HTMLElement;
    if (container) {
      container.classList.add(containerClass);
    }
  }

  private addClassToElements(selector: string, className: string) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      element.classList.add(className);
    });
  }

  private updateImageSource(selector: string, src: string) {
    const imgElements = document.querySelectorAll<HTMLImageElement>(selector);
    imgElements.forEach((img) => {
      if (img.getAttribute('src') !== src) {
        img.src = src;
      }
    });
  }

  private formatDate(date: any) {
    const [year, month, day] = date.split('-');

    return `${day}/${month}/${year}`;
  }

  private getDatenaissanceinputValue() {
    for (let i = 0; i < this.personne.enfant.dateNaissanceEnfant.length; i++) {
      let value = this.personne.enfant.dateNaissanceEnfant[i];
      this.dateNaissanceEnfant().push(this.new_enfant(value));
    }
  }

  isSlugOriginParam(): boolean {
    let parameter_codeOrigin: any = localStorage.getItem('codeOrigin');
    let paramater_paramOrigin: any = localStorage.getItem('paramOrigin');
    let values_origin_param: any = {
      afisante_affiliation: ['SWM'],
      'Mutuelle.com_affiliation': ['affiliation'],
      labonnemutuelle_affiliation: ['SWM'],
      assuranceetmutuelle_affiliation: ['SWM'],
      mutuelleonline_affiliation: ['SWM'],
    };

    if (
      values_origin_param[parameter_codeOrigin] &&
      values_origin_param[parameter_codeOrigin].includes(paramater_paramOrigin)
    ) {
      this.currentHeader = parameter_codeOrigin;
      this.currentFooter = parameter_codeOrigin;
      return true;
    } else {
      return false;
    }
  }

  isDateEffetSuperior30Days: boolean = true;
  dateEffetValideANI() {
    let value = this.aniService.isDateEffetValide(
      this.personne.dateDebutContrat,
      this.personne.dateNaissanceAssure,
      this.personne.dateNaissanceConjoint,
    );
    if (value == true) {
      return true;
    } else {
      this.isDateEffetSuperior30Days =
        this.aniService.isDateEffetSuperior30Days(
          this.personne.dateDebutContrat,
        );
      return false;
    }
  }
}
